let $39dcd949c9509e8d$var$_provider;
function $39dcd949c9509e8d$export$c6ad2801e688b6b8(provider) {
    if ($39dcd949c9509e8d$var$_provider) throw new Error("Global Provider is already set");
    $39dcd949c9509e8d$var$_provider = provider;
}
function $39dcd949c9509e8d$export$44705656a8afb801(provider) {
    $39dcd949c9509e8d$var$_provider = provider;
}
function $39dcd949c9509e8d$export$eb1aa4b5fa002353(notSetMessage) {
    if (!$39dcd949c9509e8d$var$_provider) throw new Error(notSetMessage !== null && notSetMessage !== void 0 ? notSetMessage : "Attempted to get Global AmazonConnectProvider that has not been set.");
    return $39dcd949c9509e8d$var$_provider;
}


/**
 * Type guard to verify that a value represents an AmazonConnectProvider interface.
 * Checks for the presence of required getters and methods without performing
 * runtime validation of the on/off error handling functionality.
 */ /**
 * Type guard function that verifies if a given value implements the
 * basic AmazonConnectProvider interface structure.
 *
 * @param value - The value to check for provider interface compliance
 * @returns True if the value has the required provider interface properties
 *
 * @example
 * ```typescript
 * const someValue = getUnknownValue();
 * if (isAmazonConnectProvider(someValue)) {
 *   // someValue is now typed as having provider interface
 *   console.log(someValue.id);
 *   const proxy = someValue.getProxy();
 * }
 * ```
 */ function $f7202b008cc598dc$export$3bd3119b8616ad70(value) {
    if (typeof value !== "object" || value === null) return false;
    const candidate = value;
    // Check for id getter - should be a string
    if (typeof candidate.id !== "string") return false;
    // Check for config getter - should exist (any type acceptable)
    if (!("config" in candidate)) return false;
    // Check for getProxy method - should be a function
    if (typeof candidate.getProxy !== "function") return false;
    return true;
}


class $56bfe5448b235cf5$export$aaa3fc6bdea78d4d extends Error {
    constructor({ reason: reason, namespace: namespace, errorKey: errorKey, details: details }){
        super(`ConnectError with error key "${errorKey}"`);
        this.errorType = $56bfe5448b235cf5$export$aaa3fc6bdea78d4d.ErrorType;
        this.namespace = namespace;
        this.errorKey = errorKey;
        this.reason = reason;
        this.details = details !== null && details !== void 0 ? details : {};
    }
}
$56bfe5448b235cf5$export$aaa3fc6bdea78d4d.ErrorType = "ConnectError";
function $56bfe5448b235cf5$export$fca7317dab87ae5c(error) {
    return Boolean(error instanceof $56bfe5448b235cf5$export$aaa3fc6bdea78d4d || error && typeof error === "object" && "errorType" in error && error.errorType === $56bfe5448b235cf5$export$aaa3fc6bdea78d4d.ErrorType);
}






function $1215a70c88ae5060$export$b7d58db314e0ac27(object) {
    try {
        return structuredClone(object);
    } catch (_a) {
        try {
            // Falls back to JSON parse/stringify if structureClone does not exist
            return JSON.parse(JSON.stringify(object));
        } catch (cloneError) {
            throw new (0, $56bfe5448b235cf5$export$aaa3fc6bdea78d4d)({
                errorKey: "deepCloneFailed",
                details: {
                    actualError: cloneError
                }
            });
        }
    }
}



class $962d5ec254e9281b$export$7da97068b19911b6 {
    constructor({ provider: provider, loggerKey: loggerKey }){
        this.events = new Map();
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            provider: provider,
            source: "emitter",
            mixin: ()=>({
                    emitterLoggerKey: loggerKey
                })
        });
    }
    on(parameter, handler) {
        const set = this.events.get(parameter);
        if (set) set.add(handler);
        else this.events.set(parameter, new Set([
            handler
        ]));
    }
    off(parameter, handler) {
        const set = this.events.get(parameter);
        if (set) {
            set.delete(handler);
            if (set.size < 1) this.events.delete(parameter);
        }
    }
    getHandlers(parameter) {
        var _a;
        return Array.from((_a = this.events.get(parameter)) !== null && _a !== void 0 ? _a : []);
    }
}


var $ab9a25698d62475c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $ab9a25698d62475c$export$3f06a2cb984673b7 extends (0, $962d5ec254e9281b$export$7da97068b19911b6) {
    emit(parameter, event) {
        return $ab9a25698d62475c$var$__awaiter(this, void 0, void 0, function*() {
            const handlers = this.getHandlers(parameter);
            yield Promise.allSettled(handlers.map((handler)=>$ab9a25698d62475c$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        yield handler(event);
                    } catch (error) {
                        this.logger.error("An error occurred when invoking event handler", {
                            error: error,
                            parameter: parameter
                        });
                    }
                })));
        });
    }
}



class $25849d96962ce067$export$4293555f241ae35a extends (0, $962d5ec254e9281b$export$7da97068b19911b6) {
    emit(parameter) {
        for (const handler of this.getHandlers(parameter))try {
            handler();
        } catch (error) {
            this.logger.error("An error occurred when invoking handler", {
                error: error,
                parameter: parameter
            });
        }
    }
}



class $2a114de2418d4d22$export$4fae95256245c8c0 extends (0, $962d5ec254e9281b$export$7da97068b19911b6) {
    emit(parameter, event) {
        const handlers = this.getHandlers(parameter);
        for (const handler of handlers)try {
            handler(event);
        } catch (error) {
            this.logger.error("An error occurred when invoking event handler", {
                error: error,
                parameter: parameter
            });
        }
    }
}




function $d6653d0b23f9443a$export$509983b04d69e9f3(length) {
    const a = new Uint8Array(Math.ceil(length / 2));
    crypto.getRandomValues(a);
    return Array.from(a, (d)=>d.toString(16).padStart(2, "0")).join("").substring(0, length);
}
function $d6653d0b23f9443a$export$e73c8bd0f20705a() {
    if ("randomUUID" in crypto) return crypto.randomUUID();
    else return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>{
        const d = parseInt(c);
        return (d ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> d / 4).toString(16);
    });
}


function $99aa0b032ae0f7a7$export$e34505f662d84f79() {
    var _a, _b, _c, _d;
    return {
        origin: (_b = (_a = document === null || document === void 0 ? void 0 : document.location) === null || _a === void 0 ? void 0 : _a.origin) !== null && _b !== void 0 ? _b : "unknown",
        path: (_d = (_c = document === null || document === void 0 ? void 0 : document.location) === null || _c === void 0 ? void 0 : _c.pathname) !== null && _d !== void 0 ? _d : "unknown"
    };
}



function $f757d4b67c47dbe3$export$23af04c80471b9de(proxy, namespace) {
    return {
        request: (command, data)=>proxy.request(namespace, command, data),
        subscribe: (topic, handler)=>proxy.subscribe(Object.assign(Object.assign({}, topic), {
                namespace: namespace
            }), handler),
        unsubscribe: (topic, handler)=>proxy.unsubscribe(Object.assign(Object.assign({}, topic), {
                namespace: namespace
            }), handler),
        getProxyInfo: ()=>({
                connectionStatus: proxy.connectionStatus,
                proxyType: proxy.proxyType
            }),
        onConnectionStatusChange: (h)=>proxy.onConnectionStatusChange(h),
        offConnectionStatusChange: (h)=>proxy.offConnectionStatusChange(h)
    };
}




class $27a362a16b06a5bc$export$2c5beb023b525123 {
    constructor(){
        this.idsByHandler = new Map();
        this.handlersById = new Map();
    }
    add(handler) {
        const existingId = this.idsByHandler.get(handler);
        if (existingId) return {
            handlerId: existingId
        };
        const handlerId = (0, $d6653d0b23f9443a$export$e73c8bd0f20705a)();
        this.idsByHandler.set(handler, handlerId);
        this.handlersById.set(handlerId, handler);
        return {
            handlerId: handlerId
        };
    }
    getIdByHandler(handler) {
        var _a;
        return (_a = this.idsByHandler.get(handler)) !== null && _a !== void 0 ? _a : null;
    }
    getHandlerById(id) {
        var _a;
        return (_a = this.handlersById.get(id)) !== null && _a !== void 0 ? _a : null;
    }
    get() {
        return [
            ...this.idsByHandler.entries()
        ].map(([handler, handlerId])=>({
                handler: handler,
                handlerId: handlerId
            }));
    }
    delete(handler) {
        const handlerId = this.idsByHandler.get(handler);
        if (handlerId) this.handlersById.delete(handlerId);
        this.idsByHandler.delete(handler);
        return {
            isEmpty: this.idsByHandler.size < 1
        };
    }
    size() {
        return this.idsByHandler.size;
    }
}


class $42e362b5c1e560ef$export$cca20fa98b3f18e {
    constructor(){
        this.simpleSubscriptions = new Map();
        this.paramSubscriptions = new Map();
    }
    add({ namespace: namespace, key: key, parameter: param }, value) {
        var _a, _b, _c, _d, _e;
        if (param) {
            if (!this.paramSubscriptions.has(namespace)) {
                this.paramSubscriptions.set(namespace, new Map([
                    [
                        key,
                        new Map([
                            [
                                param,
                                value
                            ]
                        ])
                    ]
                ]));
                return;
            }
            if (!((_a = this.paramSubscriptions.get(namespace)) === null || _a === void 0 ? void 0 : _a.has(key))) {
                (_b = this.paramSubscriptions.get(namespace)) === null || _b === void 0 || _b.set(key, new Map([
                    [
                        param,
                        value
                    ]
                ]));
                return;
            }
            (_d = (_c = this.paramSubscriptions.get(namespace)) === null || _c === void 0 ? void 0 : _c.get(key)) === null || _d === void 0 || _d.set(param, value);
        } else if (!this.simpleSubscriptions.has(namespace)) {
            this.simpleSubscriptions.set(namespace, new Map([
                [
                    key,
                    value
                ]
            ]));
            return;
        } else (_e = this.simpleSubscriptions.get(namespace)) === null || _e === void 0 || _e.set(key, value);
    }
    delete({ namespace: namespace, key: key, parameter: param }) {
        var _a, _b, _c, _d;
        if (param) {
            if ((_b = (_a = this.paramSubscriptions.get(namespace)) === null || _a === void 0 ? void 0 : _a.get(key)) === null || _b === void 0 ? void 0 : _b.delete(param)) {
                if (this.paramSubscriptions.get(namespace).get(key).size < 1) {
                    (_c = this.paramSubscriptions.get(namespace)) === null || _c === void 0 || _c.delete(key);
                    if (this.paramSubscriptions.get(namespace).size < 1) this.paramSubscriptions.delete(namespace);
                }
            }
        } else {
            if ((_d = this.simpleSubscriptions.get(namespace)) === null || _d === void 0 ? void 0 : _d.delete(key)) {
                if (this.simpleSubscriptions.get(namespace).size < 1) this.simpleSubscriptions.delete(namespace);
            }
        }
    }
    get({ namespace: namespace, key: key, parameter: param }) {
        var _a, _b, _c;
        if (!param) return (_a = this.simpleSubscriptions.get(namespace)) === null || _a === void 0 ? void 0 : _a.get(key);
        else return (_c = (_b = this.paramSubscriptions.get(namespace)) === null || _b === void 0 ? void 0 : _b.get(key)) === null || _c === void 0 ? void 0 : _c.get(param);
    }
    getOrAdd(topic, addFactory) {
        let value = this.get(topic);
        if (!value) {
            value = addFactory();
            this.add(topic, value);
        }
        return value;
    }
    addOrUpdate(topic, addFactory, updateAction) {
        let value = this.get(topic);
        if (value) value = updateAction(value);
        else value = addFactory();
        this.add(topic, value);
        return value;
    }
    getAllSubscriptions() {
        const noParam = Array.from(this.simpleSubscriptions.keys()).flatMap((namespace)=>Array.from(this.simpleSubscriptions.get(namespace).keys()).flatMap((key)=>({
                    namespace: namespace,
                    key: key
                })));
        const withParam = Array.from(this.paramSubscriptions.keys()).flatMap((namespace)=>Array.from(this.paramSubscriptions.get(namespace).keys()).flatMap((key)=>Array.from(this.paramSubscriptions.get(namespace).get(key).keys()).flatMap((parameter)=>({
                        namespace: namespace,
                        key: key,
                        parameter: parameter
                    }))));
        return [
            ...noParam,
            ...withParam
        ];
    }
}


class $7fe6471756982d32$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = new (0, $42e362b5c1e560ef$export$cca20fa98b3f18e)();
    }
    add(topic, handler) {
        return this.subscriptions.getOrAdd(topic, ()=>new (0, $27a362a16b06a5bc$export$2c5beb023b525123)()).add(handler);
    }
    get(topic) {
        var _a, _b;
        return (_b = (_a = this.subscriptions.get(topic)) === null || _a === void 0 ? void 0 : _a.get()) !== null && _b !== void 0 ? _b : [];
    }
    getById(topic, handlerId) {
        var _a, _b;
        return (_b = (_a = this.subscriptions.get(topic)) === null || _a === void 0 ? void 0 : _a.getHandlerById(handlerId)) !== null && _b !== void 0 ? _b : null;
    }
    delete(topic, handler) {
        var _a, _b;
        if ((_b = (_a = this.subscriptions.get(topic)) === null || _a === void 0 ? void 0 : _a.delete(handler).isEmpty) !== null && _b !== void 0 ? _b : false) this.subscriptions.delete(topic);
    }
    size(topic) {
        var _a, _b;
        return (_b = (_a = this.subscriptions.get(topic)) === null || _a === void 0 ? void 0 : _a.size()) !== null && _b !== void 0 ? _b : 0;
    }
    isEmpty(topic) {
        return this.size(topic) === 0;
    }
    getAllSubscriptions() {
        return this.subscriptions.getAllSubscriptions();
    }
    getAllSubscriptionHandlerIds() {
        return this.subscriptions.getAllSubscriptions().reduce((acc, topic)=>acc.concat(this.get(topic).map(({ handlerId: handlerId })=>({
                    topic: topic,
                    handlerId: handlerId
                }))), []);
    }
}




class $4e1050cfdac33bbd$export$2b795f1a4be2f79e {
    constructor(){
        this.map = new (0, $42e362b5c1e560ef$export$cca20fa98b3f18e)();
    }
    add(topic, value) {
        this.map.addOrUpdate(topic, ()=>new Set([
                value
            ]), (s)=>s.add(value));
    }
    delete(topic, value) {
        const s = this.map.get(topic);
        if (s) {
            s.delete(value);
            if (s.size === 0) this.map.delete(topic);
        }
    }
    get(topic) {
        var _a;
        return [
            ...(_a = this.map.get(topic)) !== null && _a !== void 0 ? _a : []
        ];
    }
    size(topic) {
        var _a, _b;
        return (_b = (_a = this.map.get(topic)) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : 0;
    }
    isEmpty(topic) {
        return this.size(topic) === 0;
    }
    getAllSubscriptions() {
        return this.map.getAllSubscriptions();
    }
}





/**
 * @classdesc DurationMetricRecorder class provides APIs to emit duration metrics based on users' need
 */ class $60d0684578151bb1$export$93cf0b6ad6c41376 {
    /**
     * Constructor for DurationMetricRecorder
     * @param {(metric: MetricData) => void} sendMetric- The method that sends metric
     * @param {string} metricName - The name of the duration metric
     * @param {Record<string, string>} dimensions - The dimensions of the duration metric with keys and values (optional)
     * @param {Record<string, string>} optionalDimensions - The optional dimensions of the duration metric with keys and values (optional)
     */ constructor({ sendMetric: sendMetric, metricName: metricName, metricOptions: metricOptions }){
        this.unit = "Milliseconds";
        this.sendMetric = sendMetric;
        this.startTime = performance.now();
        this.metricName = metricName;
        this.dimensions = (metricOptions === null || metricOptions === void 0 ? void 0 : metricOptions.dimensions) ? metricOptions.dimensions : {};
        this.optionalDimensions = (metricOptions === null || metricOptions === void 0 ? void 0 : metricOptions.optionalDimensions) ? metricOptions.optionalDimensions : {};
    }
    /**
     * Stop recording of the duration metric and emit it
     * @returns {durationCount: number} - The duration being recorded
     */ stopDurationCounter() {
        const durationResult = Math.round(performance.now() - this.startTime);
        this.sendMetric({
            metricName: this.metricName,
            unit: this.unit,
            value: durationResult,
            dimensions: this.dimensions,
            optionalDimensions: this.optionalDimensions
        });
        return {
            duration: durationResult
        };
    }
}


const $30ac685433bfbba3$export$907c9e401e5c1699 = 30;
function $30ac685433bfbba3$export$e4d9fb85c039e068(dimensions, optionalDimensions) {
    if (Object.keys(dimensions).length + Object.keys(optionalDimensions !== null && optionalDimensions !== void 0 ? optionalDimensions : {}).length > $30ac685433bfbba3$export$907c9e401e5c1699) throw new Error("Cannot add more than 30 dimensions to a metric");
}
function $30ac685433bfbba3$export$8c473f091cf29a4d({ metricData: metricData, time: time, namespace: namespace }, messageOrigin) {
    var _a, _b;
    return {
        type: "metric",
        namespace: namespace,
        metricName: metricData.metricName,
        unit: metricData.unit,
        value: metricData.value,
        time: time,
        dimensions: (_a = metricData.dimensions) !== null && _a !== void 0 ? _a : {},
        optionalDimensions: (_b = metricData.optionalDimensions) !== null && _b !== void 0 ? _b : {},
        messageOrigin: messageOrigin
    };
}


class $431810383b55eaa3$export$7bc69c3f999b033f {
    /**
     * Constructor for ConnectMetricRecorder
     * @param {ConnectRecorderMetricParams} params - The namespace and provider(optional)
     */ constructor(params){
        this._proxy = null;
        this.namespace = params.namespace;
        if (params.provider && typeof params.provider === "function") this.providerFactory = params.provider;
        else this.provider = params.provider;
    }
    /**
     * Emit a metric that counts success
     * @param {string} metricName - The name of the metric
     * @param {Record<string, string>} dimensions - The dimensions of a metric with keys and values (optional)
     * @param {Record<string, string>} optionalDimensions - The optional dimensions of a metric with keys and values (optional)
     */ recordSuccess(metricName, metricOptions) {
        var _a;
        const processedDimensions = Object.assign({}, (_a = metricOptions === null || metricOptions === void 0 ? void 0 : metricOptions.dimensions) !== null && _a !== void 0 ? _a : {});
        const processedMetricOptions = Object.assign(Object.assign({}, metricOptions), {
            dimensions: processedDimensions
        });
        this.recordCount(metricName, 0, processedMetricOptions);
    }
    /**
     * Emit a metric that counts error. Add default dimension { name: "Metric", value: "Error" } to the metric if not added
     * @param {string} metricName - The name of the metric
     * @param {Record<string, string>} dimensions - The dimensions of a metric with keys and values (optional)
     * @param {Record<string, string>} optionalDimensions - The optional dimensions of a metric with keys and values (optional)
     */ recordError(metricName, metricOptions) {
        var _a;
        const processedDimensions = Object.assign({}, (_a = metricOptions === null || metricOptions === void 0 ? void 0 : metricOptions.dimensions) !== null && _a !== void 0 ? _a : {});
        const processedMetricOptions = Object.assign(Object.assign({}, metricOptions), {
            dimensions: processedDimensions
        });
        this.recordCount(metricName, 1, processedMetricOptions);
    }
    /**
     * Emit a counting metric
     * @param {string} metricName - The name of the metric
     * @param {number} count - The count of the metric
     * @param {Record<string, string>} dimensions - The dimensions of a metric with keys and values (optional)
     * @param {Record<string, string>} optionalDimensions - The optional dimensions of a metric with keys and values (optional)
     */ recordCount(metricName, count, metricOptions) {
        this.sendMetric({
            metricName: metricName,
            unit: "Count",
            value: count,
            dimensions: metricOptions === null || metricOptions === void 0 ? void 0 : metricOptions.dimensions,
            optionalDimensions: metricOptions === null || metricOptions === void 0 ? void 0 : metricOptions.optionalDimensions
        });
    }
    /**
     * Start a duration metric
     * @param {string} metricName - The name of the metric
     * @param {Record<string, string>} dimensions - The dimensions of a metric with keys and values (optional)
     * @param {Record<string, string>} optionalDimensions - The optional dimensions of a metric with keys and values (optional)
     * @returns {DurationMetricRecorder} - The DurationMetricRecorder object being created
     */ startDurationCounter(metricName, metricOptions) {
        return new (0, $60d0684578151bb1$export$93cf0b6ad6c41376)({
            sendMetric: this.sendMetric.bind(this),
            metricName: metricName,
            metricOptions: metricOptions
        });
    }
    /**
     * Emit metric
     * @param {string} metricName - The name of the metric
     * @param {unit} unit - The unit of the metric
     * @param {number} value - The value of the metric
     * @param {Record<string, string>} dimensions - The dimensions of a metric with keys and values (optional)
     * @param {Record<string, string>} optionalDimensions - The optional dimensions of a metric with keys and values (optional)
     */ sendMetric({ metricName: metricName, unit: unit, value: value, dimensions: dimensions, optionalDimensions: optionalDimensions }) {
        if (dimensions) (0, $30ac685433bfbba3$export$e4d9fb85c039e068)(dimensions, optionalDimensions);
        const metricData = {
            metricName: metricName,
            unit: unit,
            value: value,
            dimensions: dimensions,
            optionalDimensions: optionalDimensions
        };
        const time = new Date();
        this.getProxy().sendMetric({
            metricData: metricData,
            time: time,
            namespace: this.namespace
        });
    }
    /**
     * Get the provider of the ConnectMetricRecorder instance
     */ getProvider() {
        if (!this.provider) this.provider = this.providerFactory ? this.providerFactory() : (0, $39dcd949c9509e8d$export$eb1aa4b5fa002353)();
        return this.provider;
    }
    /**
     * Get the proxy of the ConnectMetricRecorder instance
     */ getProxy() {
        if (!this._proxy) this._proxy = this.getProvider().getProxy();
        return this._proxy;
    }
}








const $c871a4598f8700a9$export$a5ecea6e25e455ea = "clientTimeout";
function $c871a4598f8700a9$export$3c69a248ff55e4a1(request, timeoutMs) {
    const { namespace: namespace, command: command, data: requestData } = request;
    return {
        namespace: namespace,
        reason: "Client Timeout",
        details: {
            command: command,
            requestData: requestData,
            timeoutMs: timeoutMs
        },
        errorKey: $c871a4598f8700a9$export$a5ecea6e25e455ea
    };
}
function $c871a4598f8700a9$export$8db8c9f6a915afb2(err) {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    typeof err === "object" && err.errorKey === $c871a4598f8700a9$export$a5ecea6e25e455ea);
}


const $281206116798b7d7$export$1dd6e4bf30895de3 = "handlerNotFound";


const $4bba8e9566363fcb$export$d282bbd722a327dc = "noResult";
function $4bba8e9566363fcb$export$6c7b100e0362757c(err) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return typeof err === "object" && err.errorKey === $4bba8e9566363fcb$export$d282bbd722a327dc;
}





const $9be4ced626fd2953$var$DEFAULT_TIMEOUT_MS = 30000;
function $9be4ced626fd2953$export$6308091d8cbd0718(request, onStart, onTimeout, timeoutMs) {
    const adjustedTimeoutMs = Math.max(1, timeoutMs !== null && timeoutMs !== void 0 ? timeoutMs : $9be4ced626fd2953$var$DEFAULT_TIMEOUT_MS);
    return new Promise((resolve, reject)=>{
        let isTimedOut = false;
        const timeout = setTimeout(()=>{
            onTimeout({
                timeoutMs: adjustedTimeoutMs,
                request: request
            });
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            reject((0, $c871a4598f8700a9$export$3c69a248ff55e4a1)(request, adjustedTimeoutMs));
            isTimedOut = true;
        }, adjustedTimeoutMs);
        const handler = (msg)=>{
            clearTimeout(timeout);
            if (!isTimedOut) {
                if (msg.isError) reject(new (0, $56bfe5448b235cf5$export$aaa3fc6bdea78d4d)(msg));
                else resolve(msg.data);
            }
        };
        onStart(handler);
    });
}


class $4d5ab870a7fe0f2a$export$5ede614062649d0a {
    constructor(provider){
        this.requestMap = new Map();
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            provider: provider,
            source: "core.requestManager"
        });
    }
    processRequest(request) {
        const { requestId: requestId } = request;
        return (0, $9be4ced626fd2953$export$6308091d8cbd0718)(request, (handler)=>this.requestMap.set(requestId, handler), ({ request: request, timeoutMs: timeoutMs })=>this.handleTimeout(request, timeoutMs));
    }
    processResponse(response) {
        const { requestId: requestId } = response;
        const handler = this.requestMap.get(requestId);
        if (!handler) {
            // The proxy is implemented such that this should never happen
            this.logger.error("Returned a response message with no handler", {
                message: response
            });
            return;
        }
        handler(response);
        this.requestMap.delete(requestId);
    }
    handleTimeout(request, timeoutMs) {
        const { requestId: requestId, namespace: namespace, command: command } = request;
        this.requestMap.delete(requestId);
        this.logger.error("Client request timeout", {
            requestId: requestId,
            namespace: namespace,
            command: command,
            timeoutMs: timeoutMs
        });
    }
}



function $aec103b3a7aa34ce$export$dc555e15cb89498e(namespace, command, data, messageOrigin) {
    const requestId = (0, $d6653d0b23f9443a$export$e73c8bd0f20705a)();
    return {
        type: "request",
        namespace: namespace,
        command: command,
        requestId: requestId,
        data: data,
        messageOrigin: messageOrigin
    };
}





var $d953bbbcdf8472b4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d953bbbcdf8472b4$export$64313743280c96fd(message) {
    try {
        switch(message.type){
            case "acknowledge":
            case "error":
            case "childConnectionClose":
                return message;
            case "childDownstreamMessage":
                return Object.assign(Object.assign({}, message), {
                    message: $d953bbbcdf8472b4$export$64313743280c96fd(message.message)
                });
            case "publish":
                {
                    const { data: data } = message, other = $d953bbbcdf8472b4$var$__rest(message, [
                        "data"
                    ]);
                    return Object.assign({}, other);
                }
            case "response":
                if (message.isError) return Object.assign(Object.assign({}, message), {
                    details: {
                        command: message.details.command
                    }
                });
                else {
                    const { data: data } = message, other = $d953bbbcdf8472b4$var$__rest(message, [
                        "data"
                    ]);
                    return Object.assign({}, other);
                }
            default:
                return message;
        }
    } catch (error) {
        return {
            messageDetails: "error when sanitizing downstream message",
            message: message,
            error: error
        };
    }
}






class $c08788ed07b3c738$export$46b19a482269ed2b {
    constructor(provider, relayChildUpstreamMessage){
        this.provider = provider;
        this.relayChildUpstreamMessage = relayChildUpstreamMessage;
        this.channels = new Map();
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            provider: provider,
            source: "childConnectionManager"
        });
    }
    /**
     * Adds a new communication channel for a child entity.
     *
     * Supports both iframe and component channel types. For iframe channels,
     * sets up message event listeners and starts the port. For component channels,
     * configures the upstream message handler. Both types send a "childConnectionReady"
     * message upstream to notify the proxy that the channel is established.
     *
     * @param params - Channel configuration parameters
     * @param params.connectionId - UUID identifier for this channel connection
     * @param params.providerId - UUID of the provider that owns this channel
     * @param params.type - Channel type: "iframe" or "component"
     *
     * @example Iframe Channel
     * ```typescript
     * const { port1, port2 } = new MessageChannel();
     * channelManager.addChannel({
     *   connectionId: "550e8400-e29b-41d4-a716-446655440000",
     *   providerId: "6ba7b810-9dad-11d1-80b4-00c04fd430c8",
     *   type: "iframe",
     *   port: port1
     * });
     * ```
     *
     * @example Component Channel
     * ```typescript
     * channelManager.addChannel({
     *   connectionId: "550e8400-e29b-41d4-a716-446655440001",
     *   providerId: "6ba7b810-9dad-11d1-80b4-00c04fd430c8",
     *   type: "component",
     *   sendDownstreamMessage: (msg) => childEntity.receive(msg),
     *   setUpstreamMessageHandler: (handler) => childEntity.onUpstream = handler
     * });
     * ```
     */ addChannel(params) {
        const { connectionId: connectionId } = params;
        if (this.channels.has(connectionId)) {
            this.logger.error("Attempted to add child connection that already exists. No action", {
                connectionId: connectionId
            });
            return;
        }
        if (params.type === "iframe") this.setupIframe(params);
        else this.setupComponent(params);
        this.logger.debug("Child channel added", {
            connectionId: connectionId,
            type: params.type
        });
    }
    /**
     * Updates an existing MessagePort channel with a new MessagePort.
     *
     * This method is only applicable to MessagePort channels. Direct channels cannot
     * be updated and will result in an error. The old MessagePort is properly cleaned up
     * (event listeners removed, port closed) before the new port is configured.
     *
     * @param params - Update parameters
     * @param params.connectionId - UUID identifier for the channel to update
     * @param params.port - New MessagePort instance to replace the existing one
     * @param params.providerId - UUID of the provider that owns this channel
     *
     * @throws Logs error if connectionId doesn't exist or channel is Direct type
     *
     * @example
     * ```typescript
     * const { port1, port2 } = new MessageChannel();
     * channelManager.updateChannelPort({
     *   connectionId: "550e8400-e29b-41d4-a716-446655440000",
     *   port: port1,
     *   providerId: "6ba7b810-9dad-11d1-80b4-00c04fd430c8"
     * });
     * ```
     */ updateChannelPort(params) {
        const { connectionId: connectionId } = params;
        const existingChannel = this.channels.get(connectionId);
        if (!existingChannel) {
            this.logger.error("Attempted to update child connection that does not exist No action", {
                connectionId: connectionId
            });
            return;
        }
        if (existingChannel.type === "component") {
            this.logger.error("Attempted to update a component channel connection as MessagePort. This is not supported.", {
                connectionId: connectionId
            });
            return;
        }
        const originalChannel = existingChannel;
        originalChannel.port.onmessage = null;
        originalChannel.port.close();
        const setupParams = Object.assign(Object.assign({}, params), {
            type: "iframe"
        });
        this.setupIframe(setupParams);
        this.logger.info("Updated child port", {
            connectionId: connectionId
        });
    }
    setupIframe(params) {
        const { connectionId: connectionId, port: port, providerId: providerId } = params;
        const handler = this.createMessageHandler(connectionId, providerId);
        port.addEventListener("message", handler);
        port.start();
        this.channels.set(connectionId, {
            type: "iframe",
            port: port,
            handler: handler,
            providerId: providerId
        });
        this.relayChildUpstreamMessage({
            type: "childUpstream",
            connectionId: connectionId,
            sourceProviderId: providerId,
            parentProviderId: this.provider.id,
            message: {
                type: "childConnectionReady"
            }
        });
    }
    setupComponent(params) {
        const { connectionId: connectionId, providerId: providerId, sendDownstreamMessage: sendDownstreamMessage, setUpstreamMessageHandler: setUpstreamMessageHandler } = params;
        const upstreamHandler = (message)=>{
            this.relayChildUpstreamMessage({
                type: "childUpstream",
                sourceProviderId: providerId,
                parentProviderId: this.provider.id,
                connectionId: connectionId,
                message: message
            });
        };
        setUpstreamMessageHandler(upstreamHandler);
        this.channels.set(connectionId, {
            type: "component",
            providerId: providerId,
            sendDownstreamMessage: sendDownstreamMessage,
            setUpstreamMessageHandler: setUpstreamMessageHandler
        });
        this.relayChildUpstreamMessage({
            type: "childUpstream",
            connectionId: connectionId,
            sourceProviderId: providerId,
            parentProviderId: this.provider.id,
            message: {
                type: "childConnectionReady"
            }
        });
    }
    /**
     * Routes a downstream message from the proxy to the appropriate child channel.
     *
     * Validates that the target channel exists and that the provider ID matches
     * (for security). For MessagePort channels, uses postMessage(). For Direct
     * channels, calls the sendDownstreamMessage function.
     *
     * @param params - Downstream message parameters
     * @param params.connectionId - UUID of the target channel
     * @param params.message - The message to send to the child entity
     * @param params.targetProviderId - Expected provider ID for validation
     *
     * @example
     * ```typescript
     * channelManager.handleDownstreamMessage({
     *   connectionId: "550e8400-e29b-41d4-a716-446655440000",
     *   message: { type: "request", data: "some data" },
     *   targetProviderId: "6ba7b810-9dad-11d1-80b4-00c04fd430c8"
     * });
     * ```
     */ handleDownstreamMessage({ connectionId: connectionId, message: message, targetProviderId: targetProviderId }) {
        const channelData = this.channels.get(connectionId);
        if (!channelData) {
            this.logger.warn("Attempted to route downstream message to child channel that does not exist", {
                connectionId: connectionId,
                message: (0, $d953bbbcdf8472b4$export$64313743280c96fd)(message)
            });
            return;
        }
        const { providerId: providerId } = channelData;
        // Older versions of the SDK do not provide a provider id. This
        // check is ignored for versions without a providerId.
        if (providerId && providerId !== targetProviderId) {
            this.logger.error("Downstream target message did not match target provider id. Not sending message.", {
                connectionId: connectionId,
                targetProviderId: targetProviderId,
                actualProviderId: providerId,
                message: (0, $d953bbbcdf8472b4$export$64313743280c96fd)(message)
            });
            return;
        }
        if (channelData.type === "iframe") channelData.port.postMessage(message);
        else channelData.sendDownstreamMessage(message);
    }
    /**
     * Handles closing a child channel and performs appropriate cleanup.
     *
     * For MessagePort channels, removes event listeners and closes the port.
     * For Direct channels, simply removes the channel from the internal map
     * since no port cleanup is needed. The channel is always removed from
     * the channels map regardless of type.
     *
     * @param params - Close message parameters
     * @param params.connectionId - UUID of the channel to close
     *
     * @example
     * ```typescript
     * channelManager.handleCloseMessage({
     *   connectionId: "550e8400-e29b-41d4-a716-446655440000"
     * });
     * ```
     */ handleCloseMessage({ connectionId: connectionId }) {
        const channelData = this.channels.get(connectionId);
        if (!channelData) {
            this.logger.warn("Attempted to close child channel that was not found", {
                connectionId: connectionId
            });
            return;
        }
        if (channelData.type === "iframe") {
            const { port: port, handler: handler } = channelData;
            port.removeEventListener("message", handler);
            port.close();
        }
        // For component channels, no cleanup of ports/handlers is needed
        this.channels.delete(connectionId);
        this.logger.debug("Removed child channel", {
            connectionId: connectionId,
            type: channelData.type
        });
    }
    createMessageHandler(connectionId, providerId) {
        return (message)=>this.relayChildUpstreamMessage({
                type: "childUpstream",
                sourceProviderId: providerId,
                parentProviderId: this.provider.id,
                connectionId: connectionId,
                message: message.data
            });
    }
}



class $5cdece29fdd8718e$export$2a652e02484984a9 {
    constructor(provider){
        this.errorHandlers = new Set();
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            provider: provider,
            source: "core.proxy.error"
        });
    }
    invoke(error) {
        const { message: message, key: key, details: details, isFatal: isFatal, connectionStatus: connectionStatus } = error;
        this.logger.error(message, {
            key: key,
            details: details,
            isFatal: isFatal,
            connectionStatus: connectionStatus
        }, {
            duplicateMessageToConsole: true,
            remoteIgnore: true
        });
        [
            ...this.errorHandlers
        ].forEach((handler)=>{
            try {
                handler(error);
            } catch (handlerError) {
                this.logger.error("An error occurred within a AmazonConnectErrorHandler", {
                    handlerError: handlerError,
                    originalError: error
                });
            }
        });
    }
    onError(handler) {
        this.errorHandlers.add(handler);
    }
    offError(handler) {
        this.errorHandlers.delete(handler);
    }
}






class $ba3cc719862c53ef$export$dd748be52f1c8b25 {
    constructor({ provider: provider, sendHealthCheck: sendHealthCheck, getUpstreamMessageOrigin: getUpstreamMessageOrigin }){
        this.connectionId = null;
        this.healthCheckInterval = null;
        this.healthCheckTimeout = null;
        this.sendHealthCheck = sendHealthCheck;
        this.getUpstreamMessageOrigin = getUpstreamMessageOrigin;
        this.sendHealthCheckInterval = null;
        this.lastHealthCheckResponse = null;
        this._status = "unknown";
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            source: "core.proxy.health-check",
            provider: provider,
            mixin: ()=>({
                    connectionId: this.connectionId
                })
        });
        this.events = new (0, $ab9a25698d62475c$export$3f06a2cb984673b7)({
            provider: provider,
            loggerKey: "core.proxy.health-check"
        });
    }
    get status() {
        return this._status;
    }
    get isRunning() {
        return this.sendHealthCheckInterval !== null;
    }
    get lastCheckCounter() {
        var _a, _b;
        return (_b = (_a = this.lastHealthCheckResponse) === null || _a === void 0 ? void 0 : _a.counter) !== null && _b !== void 0 ? _b : null;
    }
    get lastCheckTime() {
        var _a, _b;
        return (_b = (_a = this.lastHealthCheckResponse) === null || _a === void 0 ? void 0 : _a.time) !== null && _b !== void 0 ? _b : null;
    }
    start({ healthCheckInterval: interval, connectionId: connectionId }) {
        this.connectionId = connectionId;
        this.healthCheckInterval = interval;
        this.clearInterval();
        if (interval <= 0) {
            this.logger.debug("Health check disabled");
            return;
        }
        if (interval < 1000) {
            this.logger.error("Health check interval is less than 1 second. Not running", {
                interval: interval
            });
            return;
        }
        this.sendHealthCheckMessage();
        this.sendHealthCheckInterval = setInterval(()=>this.sendHealthCheckMessage(), interval);
        this.startTimeout();
    }
    stop() {
        this.clearInterval();
        this.clearTimeout();
    }
    handleResponse(message) {
        this.setHealthy({
            time: message.time,
            counter: message.counter
        });
    }
    sendHealthCheckMessage() {
        this.sendHealthCheck({
            type: "healthCheck",
            messageOrigin: this.getUpstreamMessageOrigin()
        });
    }
    startTimeout() {
        if (!this.healthCheckInterval) {
            this.logger.error("Health check interval not set. Cannot start timeout");
            return;
        }
        // Cancels a preexisting timeout to be replaced with new timeout
        this.clearTimeout();
        this.healthCheckTimeout = setTimeout(()=>{
            this.setUnhealthy();
        }, this.healthCheckInterval * 3);
    }
    clearInterval() {
        if (this.sendHealthCheckInterval) {
            clearInterval(this.sendHealthCheckInterval);
            this.sendHealthCheckInterval = null;
        }
    }
    clearTimeout() {
        if (this.healthCheckTimeout) {
            clearTimeout(this.healthCheckTimeout);
            this.healthCheckTimeout = null;
        }
    }
    setUnhealthy() {
        if (this._status !== "unhealthy") {
            const previousStatus = this._status;
            this.logger.info("Connection unhealthy", {
                previousStatus: previousStatus
            });
            this._status = "unhealthy";
            this.emitStatusChanged("unhealthy", previousStatus);
        }
    }
    setHealthy(result) {
        this.lastHealthCheckResponse = Object.assign({}, result);
        if (this._status !== "healthy") {
            const previousStatus = this._status;
            this.logger.debug("Connection healthy", {
                previousStatus: previousStatus
            });
            this._status = "healthy";
            this.emitStatusChanged("healthy", previousStatus);
        }
        this.startTimeout();
    }
    emitStatusChanged(status, previousStatus) {
        var _a, _b, _c, _d;
        this.events.emit($ba3cc719862c53ef$export$dd748be52f1c8b25.statusChangedKey, {
            status: status,
            previousStatus: previousStatus,
            lastCheckTime: (_b = (_a = this.lastHealthCheckResponse) === null || _a === void 0 ? void 0 : _a.time) !== null && _b !== void 0 ? _b : null,
            lastCheckCounter: (_d = (_c = this.lastHealthCheckResponse) === null || _c === void 0 ? void 0 : _c.counter) !== null && _d !== void 0 ? _d : null
        });
    }
    onStatusChanged(handler) {
        this.events.on($ba3cc719862c53ef$export$dd748be52f1c8b25.statusChangedKey, handler);
    }
    offStatusChanged(handler) {
        this.events.off($ba3cc719862c53ef$export$dd748be52f1c8b25.statusChangedKey, handler);
    }
}
$ba3cc719862c53ef$export$dd748be52f1c8b25.statusChangedKey = "statusChanged";





class $063dd2979bddc7af$export$7024adc4ce4e9983 {
    constructor(provider){
        this.status = "notConnected";
        this.changeHandlers = new Set();
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            source: "core.proxy.connection-status-manager",
            provider: provider,
            mixin: ()=>({
                    status: this.status
                })
        });
    }
    getStatus() {
        return this.status;
    }
    update(evt) {
        this.status = evt.status;
        this.logger.trace("Proxy Connection Status Changed", {
            status: evt.status
        });
        [
            ...this.changeHandlers
        ].forEach((handler)=>{
            try {
                handler(evt);
            } catch (error) {
                this.logger.error("An error occurred within a ProxyConnectionChangedHandler", {
                    error: error
                });
            }
        });
    }
    onChange(handler) {
        this.changeHandlers.add(handler);
    }
    offChange(handler) {
        this.changeHandlers.delete(handler);
    }
}




var $117abfbd8b3193f3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $117abfbd8b3193f3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $117abfbd8b3193f3$export$accffb5fb4579e0d {
    constructor(provider){
        this.provider = provider;
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            source: "core.proxy",
            provider: provider,
            mixin: ()=>({
                    proxyType: this.proxyType,
                    connectionId: this.connectionId
                })
        });
        this.requestManager = new (0, $4d5ab870a7fe0f2a$export$5ede614062649d0a)(provider);
        this.status = new (0, $063dd2979bddc7af$export$7024adc4ce4e9983)(provider);
        this.errorService = new (0, $5cdece29fdd8718e$export$2a652e02484984a9)(provider);
        this.upstreamMessageQueue = [];
        this.connectionEstablished = false;
        this.isInitialized = false;
        this.subscriptions = new (0, $7fe6471756982d32$export$e7dff9482a5fd23c)();
        this.connectionId = null;
        this.channelManager = new (0, $c08788ed07b3c738$export$46b19a482269ed2b)(provider, this.sendOrQueueMessageToSubject.bind(this));
        this.healthCheck = new (0, $ba3cc719862c53ef$export$dd748be52f1c8b25)({
            provider: provider,
            sendHealthCheck: this.sendOrQueueMessageToSubject.bind(this),
            getUpstreamMessageOrigin: this.getUpstreamMessageOrigin.bind(this)
        });
    }
    init() {
        if (this.isInitialized) throw new Error("Proxy already initialized");
        this.isInitialized = true;
        this.initProxy();
    }
    request(namespace, command, data, origin) {
        const msg = (0, $aec103b3a7aa34ce$export$dc555e15cb89498e)(namespace, command, data, origin !== null && origin !== void 0 ? origin : this.getUpstreamMessageOrigin());
        const resp = this.requestManager.processRequest(msg);
        this.sendOrQueueMessageToSubject(msg);
        return resp;
    }
    subscribe(topic, handler, origin) {
        const { handlerId: handlerId } = this.subscriptions.add(topic, handler);
        const msg = {
            type: "subscribe",
            topic: topic,
            messageOrigin: origin !== null && origin !== void 0 ? origin : this.getUpstreamMessageOrigin(),
            handlerId: handlerId
        };
        this.sendOrQueueMessageToSubject(msg);
    }
    unsubscribe(topic, handler, origin) {
        this.subscriptions.delete(topic, handler);
        if (this.subscriptions.isEmpty(topic)) {
            const msg = {
                type: "unsubscribe",
                topic: topic,
                messageOrigin: origin !== null && origin !== void 0 ? origin : this.getUpstreamMessageOrigin()
            };
            this.sendOrQueueMessageToSubject(msg);
        }
    }
    log(logData) {
        const logMsg = (0, $65e686d43dd6d2ca$export$ed8cdeecc94000b7)(logData, this.addContextToLogger(), this.getUpstreamMessageOrigin());
        this.sendOrQueueMessageToSubject(logMsg);
    }
    sendLogMessage(message) {
        if (message.type !== "log") {
            this.logger.error("Attempted to send invalid log message", {
                message: message
            });
            return;
        }
        message.context = Object.assign(Object.assign({}, message.context), this.addContextToLogger());
        this.sendOrQueueMessageToSubject(message);
    }
    sendMetric({ metricData: metricData, time: time, namespace: namespace }) {
        const metricMessage = (0, $30ac685433bfbba3$export$8c473f091cf29a4d)({
            metricData: metricData,
            time: time,
            namespace: namespace
        }, this.getUpstreamMessageOrigin());
        this.sendOrQueueMessageToSubject(metricMessage);
    }
    sendMetricMessage(metricMessage) {
        if (metricMessage.type !== "metric") {
            this.logger.error("Attempted to send invalid metric message", {
                metricMessage: metricMessage
            });
            return;
        }
        this.sendOrQueueMessageToSubject(metricMessage);
    }
    sendOrQueueMessageToSubject(message) {
        if (this.connectionEstablished) this.sendMessageToSubject(message);
        else this.upstreamMessageQueue.push(message);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    consumerMessageHandler(evt) {
        if (!this.isInitialized) {
            this.logger.error("Attempted to process message from subject prior to proxy being initializing. Message not processed", {
                originalMessageEventData: evt.data
            });
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const { data: data } = evt;
        if (!("type" in data)) {
            // TODO Clean this up... probably safe to ignore without logging
            this.logger.warn("Unknown inbound message", {
                originalMessageEventData: data
            });
            return;
        }
        // Naming of type confusing because outbound to worker is inbound to client
        const msg = data;
        this.handleMessageFromSubject(msg);
    }
    handleMessageFromSubject(msg) {
        this.handleDefaultMessageFromSubject(msg);
    }
    handleDefaultMessageFromSubject(msg) {
        switch(msg.type){
            case "acknowledge":
                this.handleConnectionAcknowledge(msg);
                break;
            case "response":
                this.handleResponse(msg);
                break;
            case "publish":
                this.handlePublish(msg);
                break;
            case "error":
                this.handleError(msg);
                break;
            case "childDownstreamMessage":
                this.channelManager.handleDownstreamMessage(msg);
                break;
            case "childConnectionClose":
                this.channelManager.handleCloseMessage(msg);
                break;
            case "healthCheckResponse":
                this.healthCheck.handleResponse(msg);
                break;
            default:
                this.logger.error("Unknown inbound message", {
                    originalMessageEventData: msg
                });
                return;
        }
    }
    handleConnectionAcknowledge(msg) {
        this.connectionId = msg.connectionId;
        this.logger.debug("Connection acknowledged by subject", {
            connectionId: msg.connectionId,
            queuedMessageCount: this.upstreamMessageQueue.length,
            status: msg.status
        });
        this.status.update({
            status: "ready",
            connectionId: msg.connectionId
        });
        this.connectionEstablished = true;
        // Sends any messages in queue
        while(this.upstreamMessageQueue.length){
            const msg = this.upstreamMessageQueue.shift();
            this.sendMessageToSubject(msg);
        }
        this.healthCheck.start(msg);
        this.logger.debug("Proxy connection ready", {
            connectionId: this.connectionId
        });
    }
    handleResponse(msg) {
        this.requestManager.processResponse(msg);
    }
    handlePublish(msg) {
        const { handlerId: handlerId, topic: topic } = msg;
        if (handlerId) {
            const handler = this.subscriptions.getById(topic, handlerId);
            if (handler) this.handleAsyncSubscriptionHandlerInvoke({
                handler: handler,
                handlerId: handlerId
            }, msg);
        } else this.subscriptions.get(topic).map((handlerIdMapping)=>void this.handleAsyncSubscriptionHandlerInvoke(handlerIdMapping, msg));
    }
    handleError(msg) {
        if (msg.isFatal) {
            const { message: reason, type: _ } = msg, details = $117abfbd8b3193f3$var$__rest(msg, [
                "message",
                "type"
            ]);
            this.status.update({
                status: "error",
                reason: reason,
                details: details
            });
        }
        this.publishError({
            message: msg.message,
            key: msg.key,
            details: msg.details,
            isFatal: msg.isFatal,
            proxyStatus: msg.status
        });
    }
    publishError(error) {
        const fullError = Object.assign(Object.assign({}, error), {
            connectionStatus: this.connectionStatus
        });
        this.errorService.invoke(fullError);
    }
    handleAsyncSubscriptionHandlerInvoke(_a, _b) {
        return $117abfbd8b3193f3$var$__awaiter(this, arguments, void 0, function*({ handler: handler, handlerId: handlerId }, { topic: topic, data: data }) {
            try {
                yield handler(data);
            } catch (error) {
                this.logger.error("An error occurred when handling subscription", {
                    topic: topic,
                    error: error,
                    handlerId: handlerId
                });
            }
        });
    }
    get connectionStatus() {
        return this.status.getStatus();
    }
    onError(handler) {
        this.errorService.onError(handler);
    }
    offError(handler) {
        this.errorService.offError(handler);
    }
    onConnectionStatusChange(handler) {
        this.status.onChange(handler);
    }
    offConnectionStatusChange(handler) {
        this.status.offChange(handler);
    }
    onHealthCheckStatusChanged(handler) {
        this.healthCheck.onStatusChanged(handler);
    }
    offHealthCheckStatusChanged(handler) {
        this.healthCheck.offStatusChanged(handler);
    }
    /**
     * @deprecated Use addChildIframeChannel instead. This method will be removed in a future version.
     */ addChildChannel(params) {
        // Legacy method that only supports MessagePort channels
        this.addChildIframeChannel(params);
    }
    /**
     * Adds a component-based child channel to the proxy.
     *
     * This method establishes a communication channel using component function calls instead
     * of MessagePorts. This is useful when both the proxy and child entity exist in the same
     * execution context, such as within the same browser window or iframe.
     *
     * Component channels provide better performance than iframe channels since they avoid
     * the overhead of serialization and can support synchronous communication patterns.
     *
     * @param params - Component channel configuration
     * @param params.connectionId - UUID identifier for this channel connection
     * @param params.providerId - UUID of the provider that owns this channel
     * @param params.sendDownstreamMessage - Function to send messages to the child entity
     * @param params.setUpstreamMessageHandler - Function to register upstream message handler
     *
     * @example
     * ```typescript
     * proxy.addChildComponentChannel({
     *   connectionId: "child-uuid",
     *   providerId: "provider-uuid",
     *   sendDownstreamMessage: (message) => childComponent.receive(message),
     *   setUpstreamMessageHandler: (handler) => childComponent.onUpstream = handler
     * });
     * ```
     */ addChildIframeChannel(params) {
        this.channelManager.addChannel(Object.assign(Object.assign({}, params), {
            type: "iframe"
        }));
    }
    /**
     * Adds a component-based child channel for communication with child entities.
     *
     * This method establishes a communication channel using direct function calls instead
     * of MessagePorts. This is useful when both the proxy and child entity exist in the same
     * execution context and can directly reference each other's functions.
     *
     * @param params - Configuration parameters for the component function channel
     * @param params.connectionId - Unique UUID identifier for this channel connection
     * @param params.providerId - UUID of the provider that owns this channel connection
     * @param params.sendDownstreamMessage - Function to send messages from proxy to child entity
     * @param params.setUpstreamMessageHandler - Function to register handler for messages from child entity
     *
     * @example
     * ```typescript
     * // Child entity exposes these functions
     * const childAPI = {
     *   receive: (message) => { },
     *   onUpstream: null as ((message) => void) | null
     * };
     *
     * proxy.addChildComponentChannel({
     *   connectionId: "550e8400-e29b-41d4-a716-446655440001", // UUID
     *   providerId: "6ba7b810-9dad-11d1-80b4-00c04fd430c8", // UUID
     *   sendDownstreamMessage: (message) => {
     *     childAPI.receive(message);
     *   },
     *   setUpstreamMessageHandler: (handler) => {
     *     childAPI.onUpstream = handler;
     *   }
     * });
     * ```
     */ addChildComponentChannel(params) {
        this.channelManager.addChannel(Object.assign(Object.assign({}, params), {
            type: "component"
        }));
    }
    /**
     * Updates an existing iframe channel with a new MessagePort.
     *
     * This method is only applicable to iframe channels. Component channels cannot
     * be updated and will result in an error. The old MessagePort is properly cleaned up
     * (event listeners removed, port closed) before the new port is configured.
     *
     * @param params - Update parameters
     * @param params.connectionId - UUID identifier for the channel to update
     * @param params.port - New MessagePort instance to replace the existing one
     * @param params.providerId - UUID of the provider that owns this channel
     *
     * @example
     * ```typescript
     * const { port1, port2 } = new MessageChannel();
     * proxy.updateChildIframeChannelPort({
     *   connectionId: "550e8400-e29b-41d4-a716-446655440000",
     *   port: port1,
     *   providerId: "6ba7b810-9dad-11d1-80b4-00c04fd430c8"
     * });
     * ```
     */ updateChildIframeChannelPort(params) {
        this.channelManager.updateChannelPort(params);
    }
    /**
     * @deprecated Use updateChildIframeChannelPort instead. This method will be removed in a future version.
     */ updateChildChannelPort(params) {
        this.updateChildIframeChannelPort(params);
    }
    getConnectionId() {
        if (this.connectionId) return Promise.resolve(this.connectionId);
        return new Promise((resolve, reject)=>{
            let timeout = undefined;
            const handler = (evt)=>{
                if (evt.status === "ready") {
                    this.offConnectionStatusChange(handler);
                    clearInterval(timeout);
                    resolve(evt.connectionId);
                }
            };
            timeout = setTimeout(()=>{
                this.logger.error("Timeout getting connection id");
                this.offConnectionStatusChange(handler);
                reject(new Error("Timeout getting connectionId"));
            }, 10000);
            this.onConnectionStatusChange(handler);
        });
    }
    resetConnection(reason) {
        this.logger.debug("Resetting connection", {
            reason: reason,
            connectionId: this.connectionId
        });
        this.connectionEstablished = false;
        this.status.update({
            status: "reset",
            reason: reason
        });
        const { subscriptionHandlerCount: subscriptionHandlerCount } = this.restoreAllHandler();
        this.logger.info("Resetting proxy", {
            reason: reason,
            subscriptionHandlerCount: subscriptionHandlerCount
        });
        this.logger.debug("Connection reset complete, restoring handlers", {
            subscriptionHandlerCount: subscriptionHandlerCount
        });
    }
    restoreAllHandler() {
        var _a;
        const subscriptionHandlerIds = this.subscriptions.getAllSubscriptionHandlerIds();
        // Restore all subscriptions
        subscriptionHandlerIds === null || subscriptionHandlerIds === void 0 || subscriptionHandlerIds.map(({ topic: topic, handlerId: handlerId })=>({
                type: "subscribe",
                topic: topic,
                messageOrigin: this.getUpstreamMessageOrigin(),
                handlerId: handlerId
            })).forEach((msg)=>this.sendOrQueueMessageToSubject(msg));
        return {
            subscriptionHandlerCount: (_a = subscriptionHandlerIds === null || subscriptionHandlerIds === void 0 ? void 0 : subscriptionHandlerIds.length) !== null && _a !== void 0 ? _a : -1
        };
    }
    unsubscribeAllHandlers() {
        var _a;
        const subscriptionHandlerIds = this.subscriptions.getAllSubscriptionHandlerIds();
        this.logger.info("Unsubscribing all handlers from proxy", {
            subscriptionHandlerCount: (_a = subscriptionHandlerIds === null || subscriptionHandlerIds === void 0 ? void 0 : subscriptionHandlerIds.length) !== null && _a !== void 0 ? _a : -1
        });
        subscriptionHandlerIds === null || subscriptionHandlerIds === void 0 || subscriptionHandlerIds.map(({ topic: topic })=>({
                type: "unsubscribe",
                topic: topic,
                messageOrigin: this.getUpstreamMessageOrigin()
            })).forEach((msg)=>this.sendOrQueueMessageToSubject(msg));
    }
}




var $3b774404fa0a66da$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $3b774404fa0a66da$export$edca504353408c22 {
    constructor(provider){
        this.handlersMap = new Map();
        this.provider = provider;
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            source: "subscription-handler-relay",
            provider: provider,
            mixin: ()=>({
                    namespace: this.namespace,
                    topicKey: this.topicKey
                })
        });
    }
    get supportsParameter() {
        return true;
    }
    on(handler, parameter) {
        if (parameter && !this.supportsParameter) throw new Error("on provided unsupported parameter");
        const parameterHandlerMap = this.getParameterInternalHandlerMap(handler);
        // Do not add when handler / parameter pair already exists
        if (parameterHandlerMap.has(parameter)) return;
        const internalHandler = (evt)=>$3b774404fa0a66da$var$__awaiter(this, void 0, void 0, function*() {
                if (this.skipRelay(evt)) return;
                let externalEvent;
                try {
                    externalEvent = yield this.translate(evt);
                } catch (error) {
                    this.logger.error("An error occurred when translating event", {
                        error: error,
                        parameter: parameter
                    });
                    // Stop execution. Rethrowing would produce a duplicate error message.
                    return;
                }
                try {
                    yield handler(externalEvent);
                } catch (error) {
                    this.logger.error("Error in event handler", {
                        error: error,
                        parameter: parameter
                    });
                }
            });
        parameterHandlerMap.set(parameter, internalHandler);
        this.getProxy().subscribe({
            key: this.topicKey,
            parameter: parameter
        }, internalHandler);
    }
    off(handler, parameter) {
        var _a;
        if (parameter && !this.supportsParameter) throw new Error("off provided unsupported parameter");
        const internalHandler = (_a = this.handlersMap.get(handler)) === null || _a === void 0 ? void 0 : _a.get(parameter);
        if (!internalHandler) return;
        const parameterMap = this.handlersMap.get(handler);
        if ((parameterMap === null || parameterMap === void 0 ? void 0 : parameterMap.delete(parameter)) && parameterMap.size < 1) this.handlersMap.delete(handler);
        this.getProxy().unsubscribe({
            key: this.topicKey,
            parameter: parameter
        }, internalHandler);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    skipRelay(event) {
        return false;
    }
    destroy() {
        const proxy = this.getProxy();
        for (const [externalHandler, parameterMapping] of this.handlersMap){
            for (const [parameter, internalHandler] of parameterMapping){
                proxy.unsubscribe({
                    key: this.topicKey,
                    parameter: parameter
                }, internalHandler);
                parameterMapping.delete(parameter);
            }
            this.handlersMap.delete(externalHandler);
        }
    }
    getParameterInternalHandlerMap(externalHandler) {
        if (!this.handlersMap.has(externalHandler)) this.handlersMap.set(externalHandler, new Map());
        return this.handlersMap.get(externalHandler);
    }
    getProxy() {
        if (!this.proxy) {
            const proxy = this.provider.getProxy();
            this.proxy = (0, $f757d4b67c47dbe3$export$23af04c80471b9de)(proxy, this.namespace);
        }
        return this.proxy;
    }
}



class $93cc0b09fa679d4b$export$4f589178eaa5d0d4 {
    constructor(onCancelled, timeoutMs){
        this.timeoutMs = timeoutMs;
        this.onCancelled = onCancelled;
        this.timeout = setTimeout(()=>this.handleCancel(), this.timeoutMs);
        this.status = "running";
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            source: "core.utility.timeout-tracker",
            mixin: ()=>({
                    timeoutMs: this.timeoutMs,
                    timeoutTrackerStatus: this.status
                })
        });
    }
    static start(onCancelled, ms) {
        return new $93cc0b09fa679d4b$export$4f589178eaa5d0d4(onCancelled, ms);
    }
    complete() {
        switch(this.status){
            case "running":
                return this.handleComplete();
            case "completed":
                this.logger.debug("TimeoutTracker already marked complete. No action.");
                return true;
            case "cancelled":
                this.logger.info("Attempted to complete a TimeoutTracker that has already been cancelled");
                return false;
        }
    }
    isCancelled() {
        return this.status === "cancelled";
    }
    getStatus() {
        return this.status;
    }
    handleCancel() {
        switch(this.status){
            case "running":
                this.status = "cancelled";
                this.logger.info("TimeoutTracker has timed out. Invoking onCancelled Handler");
                this.invokeOnCancelled();
                break;
            case "completed":
                this.logger.debug("Cancel operation for TimerTracker invoked after already completed. No action.");
                break;
            default:
                throw new Error("Cancel operation in TimerTracker called during an unexpected time.");
        }
    }
    handleComplete() {
        this.status = "completed";
        clearTimeout(this.timeout);
        return true;
    }
    invokeOnCancelled() {
        try {
            this.onCancelled({
                timeoutMs: this.timeoutMs
            });
        } catch (error) {
            this.logger.error("Error when attempting to invoke TimeoutTrackerCancelledHandler", {
                error: error
            });
        }
    }
}




/* eslint-disable no-console */ var $28e822b5a30bc74f$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["trace"] = 1] = "trace";
    LogLevel[LogLevel["debug"] = 2] = "debug";
    LogLevel[LogLevel["info"] = 3] = "info";
    LogLevel[LogLevel["warn"] = 4] = "warn";
    LogLevel[LogLevel["error"] = 5] = "error";
})($28e822b5a30bc74f$export$243e62d78d3b544d || ($28e822b5a30bc74f$export$243e62d78d3b544d = {}));


function $8114a313fb9f6caf$export$c86c88f4929407a2(level, message, data) {
    if (data) switch(level){
        case (0, $28e822b5a30bc74f$export$243e62d78d3b544d).error:
            console.error(message, data);
            break;
        case (0, $28e822b5a30bc74f$export$243e62d78d3b544d).warn:
            console.warn(message, data);
            break;
        case (0, $28e822b5a30bc74f$export$243e62d78d3b544d).info:
            console.info(message, data);
            break;
        case (0, $28e822b5a30bc74f$export$243e62d78d3b544d).debug:
            console.debug(message, data);
            break;
        case (0, $28e822b5a30bc74f$export$243e62d78d3b544d).trace:
            console.trace(message, data);
            break;
        default:
            console.log(message, data);
            break;
    }
    else switch(level){
        case (0, $28e822b5a30bc74f$export$243e62d78d3b544d).error:
            console.error(message);
            break;
        case (0, $28e822b5a30bc74f$export$243e62d78d3b544d).warn:
            console.warn(message);
            break;
        case (0, $28e822b5a30bc74f$export$243e62d78d3b544d).info:
            console.info(message);
            break;
        case (0, $28e822b5a30bc74f$export$243e62d78d3b544d).debug:
            console.debug(message);
            break;
        case (0, $28e822b5a30bc74f$export$243e62d78d3b544d).trace:
            console.trace(message);
            break;
        default:
            console.log(message);
            break;
    }
}


class $e2b71600b749021b$export$e8c8f6837aa5d83f {
    constructor(mixin){
        this.mixin = mixin;
    }
    getTransformedData(level, data) {
        if (!this.mixin) return data;
        return Object.assign(Object.assign({}, data !== null && data !== void 0 ? data : {}), this.mixin(data !== null && data !== void 0 ? data : {}, level));
    }
}



class $9481a96bd5a5b1cd$export$2f4c203f411e56e7 {
    constructor(param){
        this._proxy = null;
        this._logToConsoleLevel = null;
        this.loggerId = (0, $d6653d0b23f9443a$export$509983b04d69e9f3)(8);
        if (typeof param === "string") {
            this.source = param;
            this.dataTransformer = new (0, $e2b71600b749021b$export$e8c8f6837aa5d83f)(undefined);
        } else {
            this.source = param.source;
            if (param.provider && typeof param.provider === "function") this.providerFactory = param.provider;
            else this.provider = param.provider;
            this.dataTransformer = new (0, $e2b71600b749021b$export$e8c8f6837aa5d83f)(param.mixin);
            this.logOptions = param.options;
        }
    }
    trace(message, data, options) {
        this.log((0, $28e822b5a30bc74f$export$243e62d78d3b544d).trace, message, data, options);
    }
    debug(message, data, options) {
        this.log((0, $28e822b5a30bc74f$export$243e62d78d3b544d).debug, message, data, options);
    }
    info(message, data, options) {
        this.log((0, $28e822b5a30bc74f$export$243e62d78d3b544d).info, message, data, options);
    }
    warn(message, data, options) {
        this.log((0, $28e822b5a30bc74f$export$243e62d78d3b544d).warn, message, data, options);
    }
    error(message, data, options) {
        this.log((0, $28e822b5a30bc74f$export$243e62d78d3b544d).error, message, data, options);
    }
    log(level, message, data, options) {
        const transformedData = this.dataTransformer.getTransformedData(level, data);
        if (!this.ignoreRemote(options)) this.getProxy().log({
            level: level,
            source: this.source,
            loggerId: this.loggerId,
            message: message,
            data: transformedData
        });
        if (this.applyDuplicateMessageToConsole(level, options)) (0, $8114a313fb9f6caf$export$c86c88f4929407a2)(level, message, transformedData);
    }
    getProvider() {
        if (!this.provider) this.provider = this.providerFactory ? this.providerFactory() : (0, $39dcd949c9509e8d$export$eb1aa4b5fa002353)();
        return this.provider;
    }
    getProxy() {
        if (!this._proxy) this._proxy = this.getProvider().getProxy();
        return this._proxy;
    }
    applyDuplicateMessageToConsole(level, options) {
        return (options === null || options === void 0 ? void 0 : options.duplicateMessageToConsole) || this.getLogConsoleLevel() <= level;
    }
    getLogConsoleLevel() {
        var _a, _b, _c, _d;
        if (!this._logToConsoleLevel) this._logToConsoleLevel = ((_a = this.logOptions) === null || _a === void 0 ? void 0 : _a.minLogToConsoleLevelOverride) ? this.logOptions.minLogToConsoleLevelOverride : (_d = (_c = (_b = this.getProvider().config) === null || _b === void 0 ? void 0 : _b.logging) === null || _c === void 0 ? void 0 : _c.minLogToConsoleLevel) !== null && _d !== void 0 ? _d : (0, $28e822b5a30bc74f$export$243e62d78d3b544d).error;
        return this._logToConsoleLevel;
    }
    ignoreRemote(options) {
        var _a, _b, _c;
        return ((_b = (_a = this.logOptions) === null || _a === void 0 ? void 0 : _a.remoteIgnore) !== null && _b !== void 0 ? _b : false) || ((_c = options === null || options === void 0 ? void 0 : options.remoteIgnore) !== null && _c !== void 0 ? _c : false);
    }
}





function $d20ea43e343fd831$export$7ca33c02e12018a6(data) {
    if (!data) return undefined;
    try {
        return (0, $1215a70c88ae5060$export$b7d58db314e0ac27)(data);
    } catch (_a) {
        return {
            error: "Data failed to sanitize. The original data is not available"
        };
    }
}


function $65e686d43dd6d2ca$export$ed8cdeecc94000b7({ level: level, source: source, message: message, loggerId: loggerId, data: data }, context, messageOrigin) {
    // Sanitize guards against a caller provided data object containing a
    // non-cloneable object which will fail if sent through a message channel
    const sanitizedData = (0, $d20ea43e343fd831$export$7ca33c02e12018a6)(data);
    return {
        type: "log",
        level: level,
        time: new Date(),
        source: source,
        message: message,
        loggerId: loggerId,
        data: sanitizedData,
        context: context,
        messageOrigin: messageOrigin
    };
}






class $e5de97d79d81842c$export$3b0f902a42dd3cc3 {
    constructor({ config: config, proxyFactory: proxyFactory }){
        this._id = (0, $d6653d0b23f9443a$export$e73c8bd0f20705a)();
        if (!proxyFactory) throw new Error("Attempted to get Proxy before setting up factory");
        if (!config) throw new Error("Failed to include config");
        this.proxyFactory = proxyFactory;
        this._config = config;
    }
    get id() {
        return this._id;
    }
    getProxy() {
        if (!this.proxy) {
            this.proxy = this.proxyFactory(this);
            this.proxy.init();
        }
        return this.proxy;
    }
    get config() {
        return Object.assign({}, this._config);
    }
    onError(handler) {
        this.getProxy().onError(handler);
    }
    offError(handler) {
        this.getProxy().offError(handler);
    }
    static initializeProvider(provider) {
        if (this.isInitialized) {
            const msg = "Attempted to initialize provider more than one time.";
            const details = {};
            try {
                // Attempts to get the existing provider for logging
                const existingProvider = (0, $39dcd949c9509e8d$export$eb1aa4b5fa002353)();
                const logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
                    source: "core.amazonConnectProvider.init",
                    provider: existingProvider
                });
                logger.error(msg);
            } catch (e) {
                // In the event of a error when logging or attempting
                // to get provider when logging, capture the message
                // in the error being thrown
                details.loggingError = e === null || e === void 0 ? void 0 : e.message;
            }
            throw new (0, $56bfe5448b235cf5$export$aaa3fc6bdea78d4d)({
                errorKey: "attemptInitializeMultipleProviders",
                reason: msg,
                details: details
            });
        }
        (0, $39dcd949c9509e8d$export$c6ad2801e688b6b8)(provider);
        this.isInitialized = true;
        // Getting the proxy sets up the connection with subject
        provider.getProxy();
        return provider;
    }
}
$e5de97d79d81842c$export$3b0f902a42dd3cc3.isInitialized = false;







class $d04fa9536f0c7312$export$61904a395c441947 {
    constructor(engineContext, moduleNamespace){
        this.engineContext = engineContext;
        this.moduleNamespace = moduleNamespace;
    }
    get proxy() {
        if (!this.moduleProxy) {
            const proxy = this.engineContext.getProvider().getProxy();
            const moduleNamespace = this.moduleNamespace;
            this.moduleProxy = (0, $f757d4b67c47dbe3$export$23af04c80471b9de)(proxy, moduleNamespace);
        }
        return this.moduleProxy;
    }
    getProvider() {
        return this.engineContext.getProvider();
    }
    createLogger(params) {
        if (typeof params === "object") return new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)(Object.assign(Object.assign({}, params), {
            provider: ()=>this.engineContext.getProvider()
        }));
        else return new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            source: params,
            provider: ()=>this.engineContext.getProvider()
        });
    }
    createMetricRecorder(params) {
        if (typeof params === "object") return new (0, $431810383b55eaa3$export$7bc69c3f999b033f)(Object.assign(Object.assign({}, params), {
            provider: ()=>this.engineContext.getProvider()
        }));
        else return new (0, $431810383b55eaa3$export$7bc69c3f999b033f)({
            namespace: params,
            provider: ()=>this.engineContext.getProvider()
        });
    }
}


class $bab85cddd29cf0b1$export$841858b892ce1f4c {
    constructor(provider){
        this._provider = provider;
    }
    getProvider() {
        if (this._provider) return this._provider;
        else return (0, $39dcd949c9509e8d$export$eb1aa4b5fa002353)();
    }
    getModuleContext(namespace) {
        return new (0, $d04fa9536f0c7312$export$61904a395c441947)(this, namespace);
    }
}






function $01ced93f74d38a00$export$6bb982d6cff20d44({ namespace: namespace, config: config }) {
    if (config && "context" in config && config.context) return config.context;
    else if ((0, $f7202b008cc598dc$export$3bd3119b8616ad70)(config)) return new (0, $bab85cddd29cf0b1$export$841858b892ce1f4c)(config).getModuleContext(namespace);
    else return new (0, $bab85cddd29cf0b1$export$841858b892ce1f4c)(config === null || config === void 0 ? void 0 : config.provider).getModuleContext(namespace);
}


class $16df757012d3bf73$export$149b35467dcf0a63 {
    constructor(namespace, config){
        this.namespace = namespace;
        this.context = (0, $01ced93f74d38a00$export$6bb982d6cff20d44)({
            namespace: namespace,
            config: config
        });
    }
}
class $16df757012d3bf73$export$3ef9293784bce0fa {
    constructor(namespace, config){
        this.namespace = namespace;
        this.context = (0, $01ced93f74d38a00$export$6bb982d6cff20d44)({
            namespace: namespace,
            config: config
        });
    }
}












// Do not edit this file manually
const $19174ed7d53da2d8$export$ed7c830f815c21cc = "1.0.9";






class $b1b963f5129d2894$export$122994dc05ba4308 extends (0, $bab85cddd29cf0b1$export$841858b892ce1f4c) {
    constructor({ provider: provider, instanceId: instanceId, config: config, parameters: parameters, contactScope: contactScope, scope: scope, launchedBy: launchedBy }){
        super(provider);
        this.appInstanceId = instanceId;
        this.instanceId = instanceId;
        this.config = config;
        this.appConfig = config;
        this.contactScope = contactScope;
        this.scope = scope;
        this.parameters = parameters;
        this.launchedBy = launchedBy !== null && launchedBy !== void 0 ? launchedBy : {
            // Not a valid type, but launchedBy will always been provided
            // in practice for apps
            type: "unknown"
        };
    }
}



var $548e18bce2ba9a64$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $548e18bce2ba9a64$export$6a2f4e80645f051d {
    constructor(provider){
        this.provider = provider;
        this.state = {
            isRunning: false
        };
        this.isCreated = false;
        this.isDestroyed = false;
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            source: "app.lifecycleManager",
            provider: provider,
            mixin: ()=>({
                    state: this.state,
                    isCreated: this.isCreated,
                    isDestroyed: this.isDestroyed
                })
        });
    }
    get appState() {
        return Object.assign({}, this.state);
    }
    handleCreate(params) {
        return $548e18bce2ba9a64$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (this.isDestroyed) {
                this.logger.error("An attempt was Create after a Destroy. No Action", {
                    instanceId: params.context.instanceId
                });
                return;
            }
            if (this.isCreated) {
                this.logger.error("An attempt was invoke Create after it was already invoked. No Action", {
                    instanceId: params.context.instanceId
                });
                return;
            }
            this.logger.debug("Begin Lifecycle Create", {
                instanceId: params.context.instanceId
            });
            if (!((_a = this.provider.config) === null || _a === void 0 ? void 0 : _a.onCreate)) {
                const msg = "App did not specify an onCreated handler. This is required. Closing app";
                const data = {
                    appInstanceId: params.context.instanceId,
                    instanceId: params.context.instanceId
                };
                this.logger.error(msg, {
                    instanceId: params.context.instanceId
                });
                this.provider.sendFatalError(msg, data);
                return;
            }
            const { success: success } = yield this.handleLifecycleChange(Object.assign(Object.assign({}, params), {
                stage: "create"
            }), // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
            (e)=>this.provider.config.onCreate(e), true);
            if (success) {
                this.isCreated = true;
                this.sendLifecycleHandlerCompletedMessage(params.context.instanceId, "create");
            }
        });
    }
    handleLifecycleChange(evt, action, isFatal) {
        return $548e18bce2ba9a64$var$__awaiter(this, void 0, void 0, function*() {
            let success = false;
            try {
                yield action(evt);
                success = true;
            } catch (error) {
                const { instanceId: instanceId } = evt.context;
                if (isFatal) {
                    const msg = `An fatal error occurred when handling a ${evt.stage} lifecycle action. Closing app`;
                    this.logger.error(msg, {
                        instanceId: instanceId,
                        error: error
                    });
                    this.provider.sendFatalError(msg, error);
                } else this.logger.error(`An error occurred when handling a ${evt.stage} lifecycle action.`, {
                    instanceId: instanceId,
                    error: error
                });
            }
            return {
                success: success
            };
        });
    }
    sendLifecycleHandlerCompletedMessage(appInstanceId, stage) {
        this.logger.debug(`Sending lifecycle ${stage} completed signal`);
        const proxy = this.provider.getProxy();
        proxy.sendLifecycleHandlerCompleted(appInstanceId, stage);
    }
}


var $50579aebd3aec89c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $50579aebd3aec89c$export$dfae713d5b4f2bd1 extends (0, $548e18bce2ba9a64$export$6a2f4e80645f051d) {
    constructor(provider){
        super(provider);
        this.startHandlers = new Set();
        this.stopHandlers = new Set();
    }
    handleLifecycleChangeMessage(msg) {
        const context = new (0, $b1b963f5129d2894$export$122994dc05ba4308)({
            provider: this.provider,
            instanceId: msg.instanceId,
            config: msg.config,
            parameters: msg.parameters,
            contactScope: msg.contactScope,
            scope: msg.scope,
            launchedBy: msg.launchedBy
        });
        this.state.instanceId = msg.instanceId;
        this.state.appInstanceId = msg.instanceId;
        this.state.config = msg.config;
        this.state.appConfig = msg.config;
        this.state.contactScope = msg.contactScope;
        const params = {
            context: context
        };
        switch(msg.stage){
            case "create":
                return this.handleCreate(params);
            case "start":
                return this.handleStart(params);
            case "stop":
                return this.handleStop(params);
            case "destroy":
                return this.handleDestroy(params);
        }
    }
    onStart(handler, options) {
        this.startHandlers.add(handler);
        // Allows subscribers to get start information even if they add their
        // subscription after the start event fires while app is running
        if (options === null || options === void 0 ? void 0 : options.invokeIfRunning) {
            if (this.state.isRunning) this.handleLifecycleChange(Object.assign(Object.assign({}, this.getAppLifecycleChangeParams()), {
                stage: "start"
            }), (e)=>handler(e), false);
        }
    }
    onStop(handler) {
        this.stopHandlers.add(handler);
    }
    offStart(handler) {
        this.startHandlers.delete(handler);
    }
    offStop(handler) {
        this.stopHandlers.delete(handler);
    }
    handleStart(params) {
        return $50579aebd3aec89c$var$__awaiter(this, void 0, void 0, function*() {
            if (this.isDestroyed) {
                this.logger.error("An attempt was Start after a Destroy. No Action", {
                    appInstanceId: params.context.instanceId
                });
                return;
            }
            if (!this.isCreated) {
                this.logger.error("An attempt was invoke Start before Create. No Action", {
                    appInstanceId: params.context.instanceId
                });
                return;
            }
            this.state.isRunning = true;
            this.logger.info("Begin Lifecycle Start");
            const handlerRunResult = yield Promise.all([
                ...this.startHandlers
            ].map((h)=>this.handleLifecycleChange(Object.assign(Object.assign({}, params), {
                    stage: "start"
                }), (e)=>h(e), false)));
            this.logger.debug("Completed all start handlers", {
                count: this.startHandlers.size,
                errorCount: handlerRunResult.filter(({ success: success })=>!success).length
            });
        });
    }
    handleStop(params) {
        return $50579aebd3aec89c$var$__awaiter(this, void 0, void 0, function*() {
            if (this.isDestroyed) {
                this.logger.error("An attempt was Stop after a Destroy. No Action", {
                    appInstanceId: params.context.instanceId
                });
                return;
            }
            if (!this.isCreated) {
                this.logger.error("An attempt was invoke Stop before Create. No Action", {
                    appInstanceId: params.context.instanceId
                });
                return;
            }
            this.state.isRunning = false;
            this.logger.info("Begin Lifecycle Stop");
            const handlerRunResult = yield Promise.all([
                ...this.stopHandlers
            ].map((h)=>this.handleLifecycleChange(Object.assign(Object.assign({}, params), {
                    stage: "stop"
                }), (e)=>h(e), false)));
            this.logger.debug("Completed all stop handlers", {
                count: this.stopHandlers.size,
                errorCount: handlerRunResult.filter(({ success: success })=>!success).length
            });
        });
    }
    handleDestroy(params) {
        return $50579aebd3aec89c$var$__awaiter(this, void 0, void 0, function*() {
            if (this.isDestroyed) {
                this.logger.error("An attempt was invoke Destroy multiple times. No Action", {
                    appInstanceId: params.context.instanceId
                });
                return;
            }
            if (!this.isCreated) {
                this.logger.error("An attempt was invoke Destroy before Create. No Action", {
                    appInstanceId: params.context.instanceId
                });
                return;
            }
            this.isDestroyed = true;
            this.state.isRunning = false;
            this.logger.info("Begin Lifecycle Destroy");
            const { config: config } = this.provider;
            const { success: success } = yield this.handleLifecycleChange(Object.assign(Object.assign({}, params), {
                stage: "destroy"
            }), (e)=>config.onDestroy ? config.onDestroy(e) : Promise.resolve(), true);
            if (success) this.sendLifecycleHandlerCompletedMessage(params.context.instanceId, "destroy");
        });
    }
    getAppLifecycleChangeParams() {
        return {
            context: new (0, $b1b963f5129d2894$export$122994dc05ba4308)({
                provider: this.provider,
                instanceId: this.state.instanceId,
                config: this.state.config,
                contactScope: this.state.contactScope,
                scope: this.state.scope,
                parameters: this.state.parameters,
                launchedBy: this.state.launchedBy
            })
        };
    }
}



const $c33e9fe84eefd570$export$1a01ae0705bafd37 = 5000;
const $c33e9fe84eefd570$export$5805e19da86cbb3c = 1;
const $c33e9fe84eefd570$export$b9dc90d6499a9909 = 60000;
function $c33e9fe84eefd570$export$c4722e7fa247749c(config) {
    var _a, _b;
    return Math.max(1, Math.min(60000, (_b = (_a = config.workspace) === null || _a === void 0 ? void 0 : _a.connectionTimeout) !== null && _b !== void 0 ? _b : 5000));
}


class $6a22f67a27127b40$export$f9c13df72dc44a91 extends (0, $117abfbd8b3193f3$export$accffb5fb4579e0d) {
    constructor(provider, lifecycleManager){
        super(provider);
        this.channel = new MessageChannel();
        this.lifecycleManager = lifecycleManager;
        this.appLogger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            source: "app.appProxy",
            provider: provider
        });
    }
    get proxyType() {
        return "AppProxy";
    }
    sendLifecycleHandlerCompleted(appInstanceId, stage) {
        const msg = {
            type: "appLifecycleHandlerCompleted",
            stage: stage,
            appInstanceId: appInstanceId
        };
        this.sendOrQueueMessageToSubject(msg);
    }
    tryCloseApp(message, isFatalError, data) {
        const msg = {
            type: "closeApp",
            isFatalError: isFatalError !== null && isFatalError !== void 0 ? isFatalError : false,
            message: message,
            data: data
        };
        this.sendOrQueueMessageToSubject(msg);
    }
    sendServiceError(message, data) {
        const msg = {
            type: "serviceError",
            message: message,
            data: data
        };
        this.sendOrQueueMessageToSubject(msg);
    }
    publish(topic, data) {
        const msg = {
            type: "appPublish",
            topic: topic,
            data: data
        };
        this.sendOrQueueMessageToSubject(msg);
    }
    initProxy() {
        const hostInitMessage = {
            type: "connect-app-host-init",
            sdkVersion: $19174ed7d53da2d8$export$ed7c830f815c21cc,
            providerId: this.provider.id
        };
        this.status.update({
            status: "initializing"
        });
        this.channel.port1.onmessage = (evt)=>this.consumerMessageHandler(evt);
        this.connectionTimer = (0, $93cc0b09fa679d4b$export$4f589178eaa5d0d4).start(this.connectionTimeout.bind(this), (0, $c33e9fe84eefd570$export$c4722e7fa247749c)(this.provider.config));
        window.parent.postMessage(hostInitMessage, "*", [
            this.channel.port2
        ]);
        this.appLogger.debug("Send connect message to configure proxy");
    }
    sendMessageToSubject(message) {
        this.channel.port1.postMessage(message);
    }
    getUpstreamMessageOrigin() {
        if (document === null || document === void 0 ? void 0 : document.location) {
            const { origin: origin, pathname: path } = document.location;
            return {
                _type: "app",
                providerId: this.provider.id,
                origin: origin,
                path: path
            };
        } else return {
            _type: "app",
            providerId: this.provider.id,
            origin: "unknown",
            path: "unknown"
        };
    }
    handleConnectionAcknowledge(msg) {
        // ConnectionTimer will always be defined here
        if (!this.connectionTimer.complete()) {
            this.appLogger.error("Workspace connection acknowledge received after timeout. App is not connected to workspace.", {
                timeout: this.connectionTimer.timeoutMs
            });
            return;
        }
        super.handleConnectionAcknowledge(msg);
    }
    handleMessageFromSubject(msg) {
        switch(msg.type){
            case "appLifecycle":
                this.lifecycleManager.handleLifecycleChangeMessage(msg).catch((error)=>{
                    this.appLogger.error("An error occurred when invoking handleLifecycleChangeMessage", {
                        error: error
                    });
                });
                break;
            default:
                super.handleMessageFromSubject(msg);
        }
    }
    connectionTimeout(evt) {
        this.status.update({
            status: "error",
            reason: "Workspace connection timeout",
            details: Object.assign({}, evt)
        });
        this.publishError({
            message: "App failed to connect to workspace in the allotted time",
            key: "workspaceConnectTimeout",
            details: Object.assign({}, evt),
            isFatal: true,
            proxyStatus: {
                initialized: false
            }
        });
    }
    addContextToLogger() {
        const { isRunning: appIsRunning } = this.lifecycleManager.appState;
        if (document === null || document === void 0 ? void 0 : document.location) {
            const { origin: origin, pathname: path } = document.location;
            return {
                appIsRunning: appIsRunning,
                app: {
                    origin: origin,
                    path: path
                }
            };
        } else return {
            appIsRunning: appIsRunning,
            app: {
                origin: "unknown",
                path: "unknown"
            }
        };
    }
}




class $958728fa7be7422e$export$db7f1bd463a6e688 extends (0, $e5de97d79d81842c$export$3b0f902a42dd3cc3) {
    constructor(config){
        super({
            config: config,
            proxyFactory: ()=>this.createProxy()
        });
        this.lifecycleManager = new (0, $50579aebd3aec89c$export$dfae713d5b4f2bd1)(this);
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            provider: this,
            source: "app.provider"
        });
    }
    static init(config) {
        const provider = new $958728fa7be7422e$export$db7f1bd463a6e688(config);
        $958728fa7be7422e$export$db7f1bd463a6e688.initializeProvider(provider);
        return {
            provider: provider
        };
    }
    static get default() {
        return (0, $39dcd949c9509e8d$export$eb1aa4b5fa002353)("AmazonConnectApp has not been initialized");
    }
    createProxy() {
        return new (0, $6a22f67a27127b40$export$f9c13df72dc44a91)(this, this.lifecycleManager);
    }
    onStart(handler, options) {
        this.lifecycleManager.onStart(handler, options);
    }
    onStop(handler) {
        this.lifecycleManager.onStop(handler);
    }
    offStart(handler) {
        this.lifecycleManager.offStart(handler);
    }
    offStop(handler) {
        this.lifecycleManager.offStop(handler);
    }
    sendCloseAppRequest(message) {
        this.getProxy().tryCloseApp(message, false);
    }
    sendError(message, data) {
        this.logger.error(message, data);
    }
    sendFatalError(message, data) {
        this.getProxy().tryCloseApp(message, true, data ? (0, $1215a70c88ae5060$export$b7d58db314e0ac27)(data) : undefined);
    }
    subscribe(topic, handler) {
        this.getProxy().subscribe(topic, handler);
    }
    unsubscribe(topic, handler) {
        this.getProxy().unsubscribe(topic, handler);
    }
    publish(topic, data) {
        this.getProxy().publish(topic, (0, $1215a70c88ae5060$export$b7d58db314e0ac27)(data));
    }
}



var $315455e5f6363976$export$60d081d66c84d694;
(function(AppContactScope) {
    AppContactScope["CurrentContactId"] = "CURRENT_CONTACT";
})($315455e5f6363976$export$60d081d66c84d694 || ($315455e5f6363976$export$60d081d66c84d694 = {}));





class $c13faf6c5d4df0e4$export$fddb21e10d403ff6 extends (0, $548e18bce2ba9a64$export$6a2f4e80645f051d) {
    constructor(provider){
        super(provider);
    }
    handleLifecycleChangeMessage(msg) {
        const context = new (0, $cf3141d03f36cfca$export$684ad96737696e6)({
            provider: this.provider,
            instanceId: msg.instanceId,
            config: msg.config
        });
        this.state.appInstanceId = msg.appInstanceId;
        this.state.instanceId = msg.instanceId;
        this.state.appConfig = msg.appConfig;
        this.state.config = msg.config;
        const params = {
            context: context
        };
        switch(msg.stage){
            case "create":
                return this.handleCreate(params);
            default:
                this.logger.error("Attempted to send invalid stage to service", {
                    stage: msg.stage
                });
                return Promise.reject(new Error("Invalid stage sent to service. Are you using AmazonConnectService for a 3P app? Use AmazonConnectApp"));
        }
    }
}



class $ae904c14c4ee88a2$export$def7ead990eb5fc3 extends (0, $e5de97d79d81842c$export$3b0f902a42dd3cc3) {
    constructor(config){
        super({
            config: config,
            proxyFactory: ()=>this.createProxy()
        });
        this.lifecycleManager = new (0, $c13faf6c5d4df0e4$export$fddb21e10d403ff6)(this);
        this.logger = new (0, $9481a96bd5a5b1cd$export$2f4c203f411e56e7)({
            provider: this,
            source: "app.provider"
        });
    }
    static init(config) {
        const provider = new $ae904c14c4ee88a2$export$def7ead990eb5fc3(config);
        $ae904c14c4ee88a2$export$def7ead990eb5fc3.initializeProvider(provider);
        return {
            provider: provider
        };
    }
    static get default() {
        return (0, $39dcd949c9509e8d$export$eb1aa4b5fa002353)("AmazonConnectService has not been initialized");
    }
    createProxy() {
        return new (0, $6a22f67a27127b40$export$f9c13df72dc44a91)(this, this.lifecycleManager);
    }
    sendError(message, data) {
        this.logger.error(message, data);
    }
    sendFatalError(message, data) {
        this.getProxy().sendServiceError(message, data ? (0, $1215a70c88ae5060$export$b7d58db314e0ac27)(data) : undefined);
    }
    subscribe(topic, handler) {
        this.getProxy().subscribe(topic, handler);
    }
    unsubscribe(topic, handler) {
        this.getProxy().unsubscribe(topic, handler);
    }
    publish(topic, data) {
        this.getProxy().publish(topic, (0, $1215a70c88ae5060$export$b7d58db314e0ac27)(data));
    }
}



class $cf3141d03f36cfca$export$684ad96737696e6 extends (0, $bab85cddd29cf0b1$export$841858b892ce1f4c) {
    constructor({ provider: provider, instanceId: instanceId, config: config }){
        super(provider);
        this.instanceId = instanceId;
        this.config = config;
    }
}







var $26c82aadc0794c8f$export$37d3279522fbf5e2;
(function(AppRoutes) {
    AppRoutes["getCatalog"] = "app/getCatalog";
    AppRoutes["getConfig"] = "app/getConfig";
})($26c82aadc0794c8f$export$37d3279522fbf5e2 || ($26c82aadc0794c8f$export$37d3279522fbf5e2 = {}));
var $26c82aadc0794c8f$export$d947510457b87e1;
(function(AppInstanceRoutes) {
    AppInstanceRoutes["launch"] = "app-instance/launch";
    AppInstanceRoutes["destroy"] = "app-instance/destroyInstance";
})($26c82aadc0794c8f$export$d947510457b87e1 || ($26c82aadc0794c8f$export$d947510457b87e1 = {}));
var $26c82aadc0794c8f$export$6543dc72bf3a5a28;
(function(AppControllerRoutes) {
    AppControllerRoutes["getCatalog"] = "app/getCatalog";
    AppControllerRoutes["getConfig"] = "app/getConfig";
    AppControllerRoutes["launchApp"] = "app-launcher/launch";
    AppControllerRoutes["getApp"] = "app-instance/get-app-info";
    AppControllerRoutes["getApps"] = "app-manager/get-apps";
    AppControllerRoutes["focusApp"] = "app-instance/focus";
    AppControllerRoutes["closeApp"] = "app-instance/close";
})($26c82aadc0794c8f$export$6543dc72bf3a5a28 || ($26c82aadc0794c8f$export$6543dc72bf3a5a28 = {}));


const $012a4d3d0ede6aee$export$38f64a1e950d1427 = "aws.connect.workspace";


var $fa45718c3615297d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $fa45718c3615297d$export$24feea369ccae246 extends (0, $16df757012d3bf73$export$3ef9293784bce0fa) {
    constructor(config){
        super((0, $012a4d3d0ede6aee$export$38f64a1e950d1427), config);
    }
    getAppCatalog() {
        return $fa45718c3615297d$var$__awaiter(this, void 0, void 0, function*() {
            const { applications: applications } = yield this.context.proxy.request((0, $26c82aadc0794c8f$export$6543dc72bf3a5a28).getCatalog);
            return applications;
        });
    }
    getAppConfig(arnOrName) {
        return this.context.proxy.request((0, $26c82aadc0794c8f$export$6543dc72bf3a5a28).getConfig, {
            key: arnOrName
        });
    }
    launchApp(arnOrName, options) {
        const optionsCopy = Object.assign({}, options !== null && options !== void 0 ? options : {});
        if (optionsCopy.parameters) optionsCopy.parameters = (0, $1215a70c88ae5060$export$b7d58db314e0ac27)(optionsCopy.parameters);
        const requestData = {
            arnOrName: arnOrName,
            options: optionsCopy
        };
        return this.context.proxy.request((0, $26c82aadc0794c8f$export$6543dc72bf3a5a28).launchApp, requestData);
    }
    getApp(instanceId) {
        return this.context.proxy.request((0, $26c82aadc0794c8f$export$6543dc72bf3a5a28).getApp, {
            instanceId: instanceId
        });
    }
    getApps() {
        return $fa45718c3615297d$var$__awaiter(this, void 0, void 0, function*() {
            const { apps: apps } = yield this.context.proxy.request((0, $26c82aadc0794c8f$export$6543dc72bf3a5a28).getApps, {});
            return apps;
        });
    }
    focusApp(instanceId) {
        return this.context.proxy.request((0, $26c82aadc0794c8f$export$6543dc72bf3a5a28).focusApp, {
            instanceId: instanceId
        });
    }
    closeApp(instanceId) {
        return this.context.proxy.request((0, $26c82aadc0794c8f$export$6543dc72bf3a5a28).closeApp, {
            instanceId: instanceId
        });
    }
}







const $e7c9bc917acbe27c$export$2711a5155e8cceda = "aws.connect.contact";


var $d6f5213e66c69adb$export$ab8ee948a0caf291;
(function(AgentRoutes) {
    AgentRoutes["getARN"] = "agent/getARN";
    AgentRoutes["getName"] = "agent/getName";
    AgentRoutes["getState"] = "agent/getState";
    AgentRoutes["getRoutingProfile"] = "agent/getRoutingProfile";
    AgentRoutes["getChannelConcurrency"] = "agent/getChannelConcurrency";
    AgentRoutes["getExtension"] = "agent/getExtension";
    AgentRoutes["getDialableCountries"] = "agent/getDialableCountries";
    AgentRoutes["setAvailabilityState"] = "agent/setAvailabilityState";
    AgentRoutes["setAvailabilityStateByName"] = "agent/setAvailabilityStateByName";
    AgentRoutes["setOffline"] = "agent/setOffline";
    AgentRoutes["listAvailabilityStates"] = "agent/listAvailabilityStates";
    AgentRoutes["listQuickConnects"] = "agent/listQuickConnects";
})($d6f5213e66c69adb$export$ab8ee948a0caf291 || ($d6f5213e66c69adb$export$ab8ee948a0caf291 = {}));
var $d6f5213e66c69adb$export$b6661435af33fb6a;
(function(ContactRoutes) {
    ContactRoutes["getAttributes"] = "contact/getAttributes";
    ContactRoutes["getInitialContactId"] = "contact/getInitialContactId";
    ContactRoutes["getType"] = "contact/getType";
    ContactRoutes["getStateDuration"] = "contact/getStateDuration";
    ContactRoutes["getQueue"] = "contact/getQueue";
    ContactRoutes["getQueueTimestamp"] = "contact/getQueueTimestamp";
    ContactRoutes["getDescription"] = "contact/getDescription";
    ContactRoutes["getReferences"] = "contact/getReferences";
    ContactRoutes["getChannelType"] = "contact/getChannelType";
    ContactRoutes["addParticipant"] = "contact/addParticipant";
    ContactRoutes["transfer"] = "contact/transfer";
    ContactRoutes["accept"] = "contact/accept";
    ContactRoutes["clear"] = "contact/clear";
    ContactRoutes["isPreviewMode"] = "contact/isPreviewMode";
    ContactRoutes["getPreviewConfiguration"] = "contact/getPreviewConfiguration";
    ContactRoutes["engagePreviewContact"] = "contact/engagePreviewContact";
})($d6f5213e66c69adb$export$b6661435af33fb6a || ($d6f5213e66c69adb$export$b6661435af33fb6a = {}));


var $74317b8a8ffd0ca4$export$97ada59ac24934b0;
(function(ContactLifecycleTopicKey) {
    ContactLifecycleTopicKey["StartingACW"] = "contact/acw";
    ContactLifecycleTopicKey["Connected"] = "contact/connected";
    ContactLifecycleTopicKey["Destroyed"] = "contact/destroy";
    ContactLifecycleTopicKey["Missed"] = "contact/missed";
    ContactLifecycleTopicKey["Cleared"] = "contact/cleared";
    ContactLifecycleTopicKey["Incoming"] = "contact/incoming";
})($74317b8a8ffd0ca4$export$97ada59ac24934b0 || ($74317b8a8ffd0ca4$export$97ada59ac24934b0 = {}));
var $74317b8a8ffd0ca4$export$ccf27865bbe164c8;
(function(AgentTopicKey) {
    AgentTopicKey["StateChanged"] = "agent/stateChange";
    AgentTopicKey["RoutingProfileChanged"] = "agent/routingProfileChanged";
    AgentTopicKey["EnabledChannelListChanged"] = "agent/enabledChannelListChanged";
})($74317b8a8ffd0ca4$export$ccf27865bbe164c8 || ($74317b8a8ffd0ca4$export$ccf27865bbe164c8 = {}));
var $74317b8a8ffd0ca4$export$f46c51ed197e30a;
$74317b8a8ffd0ca4$export$f46c51ed197e30a || ($74317b8a8ffd0ca4$export$f46c51ed197e30a = {});


var $b2481b19af943755$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $b2481b19af943755$export$c404cebe5885e060 extends (0, $16df757012d3bf73$export$3ef9293784bce0fa) {
    constructor(config){
        super((0, $e7c9bc917acbe27c$export$2711a5155e8cceda), config);
    }
    getARN() {
        return $b2481b19af943755$var$__awaiter(this, void 0, void 0, function*() {
            const { ARN: ARN } = yield this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).getARN);
            return ARN;
        });
    }
    getName() {
        return $b2481b19af943755$var$__awaiter(this, void 0, void 0, function*() {
            const { name: name } = yield this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).getName);
            return name;
        });
    }
    getState() {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).getState);
    }
    getRoutingProfile() {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).getRoutingProfile);
    }
    getChannelConcurrency() {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).getChannelConcurrency);
    }
    getExtension() {
        return $b2481b19af943755$var$__awaiter(this, void 0, void 0, function*() {
            const { extension: extension } = yield this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).getExtension);
            return extension;
        });
    }
    /**
     * @deprecated Use `VoiceClient.listDialableCountries` instead.
     */ getDialableCountries() {
        return $b2481b19af943755$var$__awaiter(this, void 0, void 0, function*() {
            const { dialableCountries: dialableCountries } = yield this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).getDialableCountries);
            return dialableCountries;
        });
    }
    onStateChanged(handler) {
        this.context.proxy.subscribe({
            key: (0, $74317b8a8ffd0ca4$export$ccf27865bbe164c8).StateChanged
        }, handler);
    }
    offStateChanged(handler) {
        this.context.proxy.unsubscribe({
            key: (0, $74317b8a8ffd0ca4$export$ccf27865bbe164c8).StateChanged
        }, handler);
    }
    setAvailabilityState(agentStateARN) {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).setAvailabilityState, {
            agentStateARN: agentStateARN
        });
    }
    setAvailabilityStateByName(agentStateName) {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).setAvailabilityStateByName, {
            agentStateName: agentStateName
        });
    }
    setOffline() {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).setOffline, {});
    }
    listAvailabilityStates() {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).listAvailabilityStates);
    }
    listQuickConnects(queueARNs, options) {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$ab8ee948a0caf291).listQuickConnects, {
            queueARNs: queueARNs,
            options: options
        });
    }
    onEnabledChannelListChanged(handler) {
        this.context.proxy.subscribe({
            key: (0, $74317b8a8ffd0ca4$export$ccf27865bbe164c8).EnabledChannelListChanged
        }, handler);
    }
    offEnabledChannelListChanged(handler) {
        this.context.proxy.unsubscribe({
            key: (0, $74317b8a8ffd0ca4$export$ccf27865bbe164c8).EnabledChannelListChanged
        }, handler);
    }
    onRoutingProfileChanged(handler) {
        this.context.proxy.subscribe({
            key: (0, $74317b8a8ffd0ca4$export$ccf27865bbe164c8).RoutingProfileChanged
        }, handler);
    }
    offRoutingProfileChanged(handler) {
        this.context.proxy.unsubscribe({
            key: (0, $74317b8a8ffd0ca4$export$ccf27865bbe164c8).RoutingProfileChanged
        }, handler);
    }
}






var $719ba36aa3eb02a8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $719ba36aa3eb02a8$export$5391a8fedf374ce5 extends (0, $16df757012d3bf73$export$3ef9293784bce0fa) {
    constructor(config){
        super((0, $e7c9bc917acbe27c$export$2711a5155e8cceda), config);
    }
    // requests
    getAttributes(contactId, attributes) {
        const requestData = {
            contactId: contactId,
            attributes: attributes
        };
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).getAttributes, requestData);
    }
    getAttribute(contactId, attribute) {
        return $719ba36aa3eb02a8$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this.getAttributes(contactId, [
                attribute
            ]);
            return result[attribute];
        });
    }
    getInitialContactId(contactId) {
        return $719ba36aa3eb02a8$var$__awaiter(this, void 0, void 0, function*() {
            const data = yield this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).getInitialContactId, {
                contactId: contactId
            });
            return data.initialContactId;
        });
    }
    /**
     * @deprecated Use `getChannelType` instead.
     */ getType(contactId) {
        return $719ba36aa3eb02a8$var$__awaiter(this, void 0, void 0, function*() {
            const data = yield this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).getType, {
                contactId: contactId
            });
            return data.type;
        });
    }
    getStateDuration(contactId) {
        return $719ba36aa3eb02a8$var$__awaiter(this, void 0, void 0, function*() {
            const data = yield this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).getStateDuration, {
                contactId: contactId
            });
            return data.stateDuration;
        });
    }
    getQueue(contactId) {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).getQueue, {
            contactId: contactId
        });
    }
    getQueueTimestamp(contactId) {
        return $719ba36aa3eb02a8$var$__awaiter(this, void 0, void 0, function*() {
            const data = yield this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).getQueueTimestamp, {
                contactId: contactId
            });
            return data.queueTimestamp;
        });
    }
    onStartingAcw(handler, contactId) {
        this.context.proxy.subscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).StartingACW,
            parameter: contactId
        }, handler);
    }
    /**
     * @deprecated Use `onCleared` instead.
     */ onDestroyed(handler, contactId) {
        this.context.proxy.subscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).Destroyed,
            parameter: contactId
        }, handler);
    }
    onConnected(handler, contactId) {
        this.context.proxy.subscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).Connected,
            parameter: contactId
        }, handler);
    }
    onMissed(handler, contactId) {
        this.context.proxy.subscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).Missed,
            parameter: contactId
        }, handler);
    }
    onIncoming(handler, contactId) {
        this.context.proxy.subscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).Incoming,
            parameter: contactId
        }, handler);
    }
    offStartingAcw(handler, contactId) {
        this.context.proxy.unsubscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).StartingACW,
            parameter: contactId
        }, handler);
    }
    /**
     * @deprecated Use `offCleared` instead.
     */ offDestroyed(handler, contactId) {
        this.context.proxy.unsubscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).Destroyed,
            parameter: contactId
        }, handler);
    }
    offMissed(handler, contactId) {
        this.context.proxy.unsubscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).Missed,
            parameter: contactId
        }, handler);
    }
    offIncoming(handler, contactId) {
        this.context.proxy.unsubscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).Incoming,
            parameter: contactId
        }, handler);
    }
    offConnected(handler, contactId) {
        this.context.proxy.unsubscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).Connected,
            parameter: contactId
        }, handler);
    }
    getChannelType(contactId) {
        return $719ba36aa3eb02a8$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).getChannelType, {
                contactId: contactId
            });
        });
    }
    addParticipant(contactId, quickConnect) {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).addParticipant, {
            contactId: contactId,
            quickConnect: quickConnect
        });
    }
    transfer(contactId, quickConnect) {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).transfer, {
            contactId: contactId,
            quickConnect: quickConnect
        });
    }
    onCleared(handler, contactId) {
        this.context.proxy.subscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).Cleared,
            parameter: contactId
        }, handler);
    }
    offCleared(handler, contactId) {
        this.context.proxy.unsubscribe({
            key: (0, $74317b8a8ffd0ca4$export$97ada59ac24934b0).Cleared,
            parameter: contactId
        }, handler);
    }
    accept(contactId) {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).accept, {
            contactId: contactId
        });
    }
    clear(contactId) {
        return this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).clear, {
            contactId: contactId
        });
    }
    isPreviewMode(contactId) {
        return $719ba36aa3eb02a8$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).isPreviewMode, {
                contactId: contactId
            });
            return response.isPreviewMode;
        });
    }
    getPreviewConfiguration(contactId) {
        return $719ba36aa3eb02a8$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).getPreviewConfiguration, {
                contactId: contactId
            });
            return response;
        });
    }
    engagePreviewContact(contactId) {
        return $719ba36aa3eb02a8$var$__awaiter(this, void 0, void 0, function*() {
            return this.context.proxy.request((0, $d6f5213e66c69adb$export$b6661435af33fb6a).engagePreviewContact, {
                contactId: contactId
            });
        });
    }
}




/**
 * States that a contact can be in.
 */ var $d9e5586abdeea936$export$5a8b0875c6b18ba1;
$d9e5586abdeea936$export$5a8b0875c6b18ba1 || ($d9e5586abdeea936$export$5a8b0875c6b18ba1 = {});
var $d9e5586abdeea936$export$26412bbc9ffc9c73;
$d9e5586abdeea936$export$26412bbc9ffc9c73 || ($d9e5586abdeea936$export$26412bbc9ffc9c73 = {});







const $b5edb57edb8111df$var$LOG_PREFIX = "[background-service]";
// Initialize the Amazon Connect Service
const { provider: $b5edb57edb8111df$var$provider } = (0, $ae904c14c4ee88a2$export$def7ead990eb5fc3).init({
    onCreate: async (event)=>{
        const { instanceId: instanceId } = event.context;
        console.log(`${$b5edb57edb8111df$var$LOG_PREFIX} Service creation complete for instance:`, instanceId);
        // Reuse shared clients instead of recreating them in every handler.
        const appControllerClient = new (0, $fa45718c3615297d$export$24feea369ccae246)();
        const contactClient = new (0, $719ba36aa3eb02a8$export$5391a8fedf374ce5)();
        // Expose helpers for debugging from the browser console.
        // In DevTools, select this service's iframe as the execution context,
        // then you can run:
        //   await window.__amazonConnectService.getApps()
        //   await window.__amazonConnectService.appControllerClient.getApps()
        if (typeof window !== "undefined") {
            window.__amazonConnectService = window.__amazonConnectService || {};
            window.__amazonConnectService.appControllerClient = appControllerClient;
            window.__amazonConnectService.getApps = async ()=>appControllerClient.getApps();
        }
        try {
            const apps = await appControllerClient.getApps();
            console.log(`${$b5edb57edb8111df$var$LOG_PREFIX} Active app instances in workspace:`, apps);
        } catch (error) {
            console.error("Failed to retrieve active apps:", error);
        }
        const focusLastCasesApp = async ()=>{
            const apps = await appControllerClient.getApps();
            console.log(`${$b5edb57edb8111df$var$LOG_PREFIX} Apps:`, apps);
            const casesApps = Array.isArray(apps) ? apps.filter((app)=>{
                const name = app?.config?.name;
                const arn = app?.config?.arn;
                return name === "CasesFirstPartyApp" || typeof arn === "string" && arn.includes("CasesFirstPartyApp");
            }) : [];
            console.log(`${$b5edb57edb8111df$var$LOG_PREFIX} CasesApps:`, casesApps);
            if (casesApps.length < 1) {
                console.warn("No CasesFirstPartyApp instances found", {
                    count: casesApps.length
                });
                return;
            }
            const targetApp = casesApps[casesApps.length - 1]; // last Cases app
            const targetInstanceId = targetApp?.instanceId;
            if (!targetInstanceId) {
                console.warn("Target CasesFirstPartyApp instance missing instanceId", {
                    targetApp: targetApp
                });
                return;
            }
            const focusedAppResp = await appControllerClient.focusApp(targetInstanceId);
            console.log(`${$b5edb57edb8111df$var$LOG_PREFIX} Focused last CasesFirstPartyApp instance:`, {
                instanceId: targetInstanceId,
                focusedAppResp: focusedAppResp
            });
        };
        const handleContactForCases = async (contactEvent, allowedChannelTypes, label)=>{
            try {
                console.log(`${$b5edb57edb8111df$var$LOG_PREFIX} Contact ${label}:`, {
                    contactEvent: contactEvent
                });
                console.log(`${$b5edb57edb8111df$var$LOG_PREFIX} Contact ID:`, contactEvent.contactId);
                const channel = await contactClient.getChannelType(contactEvent.contactId);
                console.log(`${$b5edb57edb8111df$var$LOG_PREFIX} Contact channel:`, channel);
                const attributes = await contactClient.getAttributes(contactEvent.contactId, "*");
                console.log(`${$b5edb57edb8111df$var$LOG_PREFIX} Contact attributes:`, attributes);
                if (!allowedChannelTypes.includes(channel.type)) {
                    console.log(`${$b5edb57edb8111df$var$LOG_PREFIX} Contact is not an allowed channel (${allowedChannelTypes.join("/")}), skipping`);
                    return;
                }
                await focusLastCasesApp();
            } catch (err) {
                console.error("Error handling contact focus logic:", err);
            }
        };
        // Voice & chat: focus Cases tab when ACW starts.
        contactClient.onStartingAcw(async (contactEvent)=>handleContactForCases(contactEvent, [
                "voice",
                "chat"
            ], "starting ACW"));
        // Task: focus Cases tab when contact is connected.
        contactClient.onConnected(async (contactEvent)=>handleContactForCases(contactEvent, [
                "task"
            ], "connected"));
    },
    onDestroy: ()=>{
        console.log(`${$b5edb57edb8111df$var$LOG_PREFIX} Service destroyed. Cleaning up resources.`);
    // Add cleanup logic here
    }
});


//# sourceMappingURL=amazon-connect-service.b375638f.js.map
